/* eslint-disable no-useless-escape */
<template>
    <div class="page-editor">
      <CRow class="align-items-start">
    <CCol col="12" xl="10">
      <CCard class="pr-0">

        <CCardBody>
          <a-card class="edit-card" style="margin:0;" :loading="saving">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted" >
                              <span class="d-xl-none" style="white-space:nowrap;float:right;" v-if="permissions && !permissions.includes('hideNextPrev')">
                                <router-link v-if="prev" :to="'/edit-content/' + prev"><a-button size="small" style="min-width:28px;min-height:28px;padding:0 6px;font-size:12px;"><i class="fas fa-arrow-left"></i></a-button></router-link>
                                <router-link v-if="next" :to="'/edit-content/' + next" class="ml-1"><a-button size="small" style="min-width:28px;min-height:28px;padding:0 6px;font-size:12px;"><i class="fas fa-arrow-right"></i></a-button></router-link>
                              </span>
                              <span v-if="!isNaN(id) || !isNaN(mid)">Upravuje sa <span class="text-lowercase"><router-link :to="'/content/' + cttt">{{ct}}</router-link></span> </span><span v-else>Pridávate obsah <span style="text-transform: lowercase;"><router-link :to="'/content/' + id">{{contenttype.title}}</router-link></span></span>
                            </h6>
                            <div class="orders-header-row">
                              <span class="title-truncate" style="font-size:16px;">{{fieldData['title']}}</span>
                            </div>
                          </span>
                          <span slot="extra">
                            <!-- Desktop: all buttons -->
                            <span class="d-none d-xl-inline">
                            <template v-if="permissions">
                            <div class="prev-next" v-if="!permissions.includes('hideNextPrev')">
                 <router-link v-if="prev" :to="'/edit-content/' + prev" :title="'Predchádzajúci obsah typu ' + ct"><a-button><i class="fas fa-arrow-left"></i></a-button></router-link>
                 <router-link :to="'/edit-content/' + next"  v-if="next" :title="'Nasledujúci obsah typu ' + ct"><a-button><i class="fas fa-arrow-right"></i></a-button></router-link>
                </div>
              </template>
              <template v-if="permissions">
                <router-link :to="'/add-content/' + cttt" v-if="!isNaN(id) && permissions.includes('addContentFromType')">
                        <a-button type="secondary" class="ml-2">Nový obsah</a-button>
              </router-link>
              </template>
              <template v-for="translation in translations">
              <template v-if="translation.target != id">
              <router-link :to="'/edit-content/'+translation.target" class="ml-2 float-right"> <a-button type="secondary" >{{ translation.lang }}</a-button></router-link>
              </template>
              </template>
              <template v-if="permissions">
              <template v-if="permissions.includes('externalImages')">
              <a-button class="ml-2" @click="openImageModal()">Nahrať externé obrázky</a-button>
              </template>
              </template>
            </span>
            </span>
                        <!-- Mobile: toolbar under title -->
                        <div class="d-xl-none mobile-toolbar" style="padding: 8px 16px; justify-content: flex-end;">
                          <a-button type="primary" size="small" @click="handleSubmit">Uložiť</a-button>
                          <router-link :to="'/add-content/' + cttt" v-if="!isNaN(id) && permissions && permissions.includes('addContentFromType')" class="ml-1">
                            <a-button size="small">Nový obsah</a-button>
                          </router-link>
                          <template v-for="translation in translations">
                            <router-link v-if="translation.target != id" :to="'/edit-content/'+translation.target" :key="'mtr-'+translation.target" class="ml-1">
                              <a-button size="small">{{ translation.lang }}</a-button>
                            </router-link>
                          </template>
                          <a-dropdown class="ml-1">
                            <a-button size="small"><i class="fas fa-ellipsis-v"></i></a-button>
                            <a-menu slot="overlay">
                              <a-menu-item v-if="fieldData.url"><a :href="vars.site_url + '/' + fieldData.language + '/' + fieldData.url" target="_blank">Zobraziť stránku</a></a-menu-item>
                              <a-menu-item @click="cloneNode">Klonovať stránku</a-menu-item>
                              <a-menu-item v-if="fieldData['language'] === 'sk'"><router-link :to="'/translate/' + id">Preložiť stránku</router-link></a-menu-item>
                              <a-menu-divider />
                              <a-menu-item @click="confirm(id)" style="color:red;">Zmazať stránku</a-menu-item>
                            </a-menu>
                          </a-dropdown>
                        </div>
                        <a-tabs :animated="false" v-model="activeContentTab">

                  <template v-for="(group,gid) in contenttype.groups">
                        <a-tab-pane :key="gid"  :tab="group.name" v-if="group.child.length">
                        <template>

                                <div class="pl-4 pr-4">
                                    <div class="row">
                        <div class="col-lg-12" :key="index" v-for="(field, index) in group.child">

                            <template v-if="field.type === '17'">
                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                              <span class="field-collection mb-3">
                              <draggable  @change="updateMultiOrder" v-bind="dragOptions" :key="componentKey" v-model="fieldData[field.slug]" :group="'fieldcollection' + index" @start="drag=true" @end="drag=false" handle=".handle2">
                                    <span :style="'display:inline-block; width:100%;' + (fieldData[field.slug].length > 1 ? 'border-bottom:0px solid #fff;':'')" :key="componentKey + '_' + indexx" v-for="(fiel,indexx) in fieldData[field.slug]">
                                        <div class="row" style="position:relative" v-if="field.fields">
                                        <a class="handle2" v-if="fieldData[field.slug].length > 1"><i class="fa fa-expand-arrows-alt"></i></a>
                                        <template v-for="(fieldinput,inde) in field.fields[0]">
                                        <field :styles="styles" :input="fieldinput" :key="componentKey + '_' + inde + '_' + indexx" :i="indexx" v-model="fiel[inde]" :options="fieldinput.options" :cl="field.fields[0].length" /></template>
                                        <a-icon class="del-but float-right" title="Odobrať položku" type="minus-circle-o" v-if="fieldData[field.slug].length > 0" @click="() => removefc(indexx,field.slug)"/></div>
                                    </span>
                              </draggable>
                                  <div v-if="field.multi === '1'" style="margin-left:20px; margin-top:18px">
                                  <a-button type="dashed" class="  float-right" @click="addColfields(field.fid)"><a-icon type="plus" style="display:block;margin-top:2px;float:left;" /> Pridať</a-button>
                                  </div>
                                  </span>
                                  </a-form-item>
                            </template>
                                           <div class="form-item-holder mb-3" v-if="field.type === '1'">
                                               <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                               <a-input alternative=""
                                                        :key="componentKey"
                                                        input-classes="form-control-alternative"
                                                        v-model="fieldData[field.slug]"
                                            />
                                            <a-button  @click="setUrl"  v-if="field.slug === 'url' && fieldData['title']">Vygeneruj automatické url z názvu</a-button>
                                            <i class="fal fa-globe-europe auto-url" title="Preložiť" v-if="field.translatable === '1'"></i>
                                               <div class="sub-translations" v-if="field.translatable === '1'">
<div class="translation" style="position:relative;"  :key="componentKey + translate.short" v-for="translate in languages">
                                                <div  v-if="fieldData.language !== translate.short">
                                                    <a-input alternative=""
                                                               input-classes="form-control-alternative"
                                                               v-model="fieldData[field.slug + ':' + translate.short]"/>
    <i style="position:absolute;top:10px;right:15px" title="Preložiť">{{translate.title}}</i></div>
                                               </div>
                                               </div>
                                               <template v-else>

                                                <div v-if="fieldData.language !== defaultLanguage && field.slug !='url' && field.translate != '1'">
                                                  <a-button title="Preložiť pomocou AI" @click="translateAI(fieldData.language, fieldData[field.slug], field.slug,false)">prelož pomocou AI</a-button>
                                               </div>

                                               </template>
                                               </a-form-item>
                                           </div>


<div  v-if="field.type === '6'">
                                           <a-form-item :label="field.title" :labelCol="labelCol"  :wrapperCol="wrapperCol">
                                               <a-input  class="mb-3" alternative=""
                                                        input-classes="form-control-alternative"
                                                        type="number"
                                                        v-model="fieldData[field.slug]"/>
                                                      </a-form-item>
                                                      </div>
                                            <div  class="mb-3" v-if="field.type === '5'" >
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                            <a-input alternative=""
                                                        input-classes="form-control-alternative"
                                                        type="number"
                                                        v-model="fieldData[field.slug]" />
                                                        </a-form-item>
 </div>
   <div class="mb-4" v-if="field.type === '28'" :key="componentKey">
                                              <template v-if="fieldData[field.slug]">

                                                <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                  <div class="table-responsive">
                                                <table class="w-100 table-small" style="border:1px solid #eee;margin-top:10px;">
<thead>
                                                  <tr class="w-100">
                                                  <template v-for="x in fieldData[field.slug + '_datax']">
                                                    <th :key="'tha' + x.type + x.slug">{{x.title}}</th>
                                                  </template>
                                                  <th></th>
                                                  </tr>
                                                  </thead>
                                                  <tbody>
                                                  <template v-for="c,d in fieldData[field.slug]">
                                                     <tr :key="field.slug + 'fsi' + field.id + d">
                                                      <template v-for="cd,df in c">
                                                          <template v-if="df != 'id'">
                                                            <td :key="field.slug + 'fseai' + d + field.id + df">
                                                              <template v-if="!cd"><i class="fa fa-times"></i></template>
                                                              <template v-else>
                                                                <template v-if="fieldData[field.slug + '_datax']">
                                                                <template v-if="fieldData[field.slug + '_datax'][df]">
                                                                <template v-if="fieldData[field.slug + '_datax'][df].type != '9'">{{cd}}</template>
                                                                <template v-else><a-row><a-col :span="4">{{ JSON.parse(cd).count }} </a-col><a-col :span="20"><a-button size="small" @click="updateField(c.id,df,field.slug)" class="ml-2">aktualizovať</a-button></a-col></a-row></template>
                                                                </template>
                                                                <template v-else>{{cd}}</template>
                                                              </template>
                                                              </template>
                                                            </td>
                                                          </template>
                                                      </template>
                                                    <td class="text-right">
                                                      <a-button class="mr-2" @click="getCTdetail(false,c.id)">detail položky</a-button>
                                                      <span><router-link :to="'/edit-content/' + c.id"><a-button>upraviť</a-button></router-link></span>
                                                    </td>
                                                   </tr>
                                                    </template>
                                                    </tbody>
                                                </table>
                                                </div>
                                                </a-form-item>
                                            </template>
                                               <div class="mt-2 mb-3 text-right w-100">
  <a-button type="primary" @click="addContent(field.id, field.title)">
    + Pridať &nbsp;<span style="padding-left:5px;text-transform:lowercase">{{ field.title }}</span>
  </a-button>
</div>

                                            </div>

                                            <div class="form-item-holder mb-3" v-if="field.type === '4'" >
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">

                                                <ckeditor :editor="editor" v-model="fieldData[field.slug]"  :config="editorConfig"  @ready="onReady"></ckeditor>
                                                <i class="fal fa-globe-europe auto-url" title="Preložiť" v-if="field.translatable === '1'"></i>
                                                <div class="sub-translations" style="margin-top:10px;" v-if="field.translatable === '1'">
                                                    <div class="translation" style="position:relative;"  :key="componentKey + translate.short" v-for="translate in languages">
                                                        <div  v-if="fieldData.language !== translate.short">
                                                            <ckeditor :editor="editor" v-model="fieldData[field.slug + ':' + translate.short]"  @ready="onReady" :config="editorConfig"></ckeditor>
                                                            <i style="position:absolute;top:10px;right:15px">{{translate.title}}</i></div>
                                                    </div>
                                                </div>
                                                <template v-else><div v-if="fieldData.language !== defaultLanguage && field.slug !='url' && field.translate != '1'">
                                                  <a-button title="Preložiť pomocou AI" @click="translateAI(fieldData.language, fieldData[field.slug], field.slug,false)">prelož pomocou AI</a-button>
                                               </div>
                                               </template>
                                              </a-form-item>
                                            </div>
                                            <div class=" mb-3" v-if="field.type === '2'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <a-select style="width: 100%"   :filter-option="(e,f) => compareData(e,f,field.id)" v-if="field.multi === '0'" defaultValue="1"  v-model="fieldData[field.slug]" :options="options[field.id]"/>
                                                <a-select v-else  mode="multiple" defaultValue="1" v-model="fieldData[field.slug]"   :filter-option="(e,f) => compareData(e,f,field.id)" :options="options[field.id]"/>
                                                <span v-if="field.multi === '0' && fieldData[field.slug]"><router-link :to="'/content/' + cttt + '?filter_' + field.id + '=' + fieldData[field.slug]"><a-button class="mr-1 mt-1">filtrovať podobné</a-button></router-link></span>
                                            </a-form-item>
                                                </div>
                                                <template v-if="field.type === '7'">
                                                  <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                    <a-checkbox class="mb-3" v-model="fieldData[field.slug]" />
                                                  </a-form-item>
                                                </template>


                                            <div class="mb-3" v-if="field.type === '3'" :key="reloadgalleries">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <image-upload :data="fieldData[field.slug]" :label="field.title" :dat="field.slug"  @changed="(e) => onChildChange(e,field.slug)"></image-upload>
                                                </a-form-item>

                                            </div>
                                            <div class="mb-3" v-if="field.type === '19' && field.multi !== '1'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                 <upload :data="fieldData[field.slug]" :label="field.title" :dat="field.slug"  @changed="(e) => onChildChange(e,field.slug)"></upload>
                                              </a-form-item>
                                            </div>




                                            <div class="mb-3" v-if="field.type === '11'" :key="reloadgalleries">

                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">

                                                <a-upload-dragger
                                                        name="upload"
                                                        :multiple="true"
                                                        :customRequest="(e) => testo(e,field.slug)"
                                                        :headers="head"
                                                        :showUploadList="false"
                                                >
                                                    <p class="ant-upload-drag-icon" style="padding-top:20px;color:#c3e8fc">
                                                      <i class="far fa-file-image" style="font-size:46px;"></i>
                                                    </p>
                                                    <p class="ant-upload-text">
                                                     Klikni, alebo premiestni súbory do tohoto poľa
                                                    </p>

                                                </a-upload-dragger>
                                                <a-button @click="openImageModal(field.slug)" >Nahrať obrázky</a-button>
<div class="setup-panel" v-if="fieldData[field.slug] && JSON.parse(fieldData[field.slug])[Object.keys(JSON.parse(fieldData[field.slug]))[0]]">

<div class="gallery-images" :key="fieldData[field.slug]" v-if="fieldData[field.slug]">
    <draggable tag="div" @change="(e) => log(e,field.slug)" :list="JSON.parse(fieldData[field.slug])" v-bind="dragOptions" @start="drag=true" @end="drag=false"  class="list-group" handle=".handler">
    <div v-for="(imageItem,index) in JSON.parse(fieldData[field.slug])" class="gallery-image-holder" :key="'img'+field.slug+'_'+index">
        <span class="handler"><div class="title" v-if="imageItem.image.title">{{imageItem.image.title}}</div>
<div class="alttag" v-if="imageItem.image.alt">{{imageItem.image.alt}}</div>
<img class="big" :src="IMG_URL + '300:300:1/' + (imageItem.image.relative.startsWith('/') ? imageItem.image.relative.substring(1) : imageItem.image.relative)">
<div class="image-setup"><a-icon type="edit" @click="setupImage(imageItem.image,index,field.slug)"/><a-icon type="delete" @click="deleteThis(index,field.slug)"/></div></span>
    </div></draggable>
</div></div>
</a-form-item>
                                            </div>



<div class="mb-3"  v-if="field.type === '22'">
  <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
  <a-row :gutter="36">
    <a-col :span="18">
<a-form-item :label-col="{span: 24}" :wrapper-col="{span: 24}"   class="mb-0">

<a-input-search
placeholder="Vyhľadávanie v položkách"
@search="(e) => fetchUser(e,context[field.id])"
/>
</a-form-item>


<a-spin v-if="fetching" slot="notFoundContent" size="small" />
<div class="finduser clickable-td" v-if="searchdata.length > 0" style="max-height:300px;overflow-y:scroll" >
<div class="mb-3">Výsledky vyhľadávania:</div>
<table class="w-100" >
<template  v-for="user in searchdata">
   <tr :key="user.id" class="selectable-row">
   <td v-if="user.image" style="width:60px;text-align:center;"><span><img :src="user.image.styled" height="40" style="max-width:100%;"></span></td>
   <td v-else style="text-align:center;">-</td>
   <td style="width:25%;display:block;"><template v-if="user.brand">{{user.brand}} - </template>{{user.value}}</td>
   <td style="width:25%;display:block;"><a :href="vars.site_url + '/' + fieldData.language + '/' + user.url" target="_blank">{{user.url}}</a></td>
   <td v-if="user.price" style="width:20%;display:block;text-align:right;">{{user.price}} €</td>
   <td v-else style="width:20%;display:block;text-align:center;">-</td>
   <td style="width:20%;text-align:right;display:block;"><a-button @click="addProductItem(field.slug,user)">+ pridať</a-button></td>
   </tr>
</template>
</table>
</div>
</a-col>
  <a-col :span="6">
<draggable v-bind="dragOptions" v-model="fieldData[field.slug]" @change="refreshassignlist++" :group="'newcomponents' + field.slug" @start="drag=true" :key="refreshassignlist" @end="drag=false" handle=".handle" class="rearange-table">
  <transition-group>
<template v-for="(spn,ind) in fieldData[field.slug]">
  <div :key="'spn' + spn.value" class="w-100">
    <a class="handle mr-2"><i class="fa fa-expand-arrows-alt"></i></a>{{ spn.label }}
    <a class="float-right" @click="removeItemFrom(field.slug,ind)">x</a></div>
</template>
  </transition-group>
  </draggable>
        </a-col>


</a-row>
</a-form-item>
</div>

<div class="mb-3" v-if="field.type === '21'">
  <a-form-item
    :label="field.title"
    :labelCol="labelCol"
    :wrapperCol="wrapperCol"
  >
   <GpsMapPicker
  :value="resolveAddress(field.slug)"
  @change="(val) => onMapChange(val, field.slug)"
/>


    <div v-if="fieldData[field.slug]" class="mt-2 small text-muted">
      <template v-if="fieldData[field.slug].address">
        Adresa: {{ fieldData[field.slug].address }}
      </template>

      <template v-if="fieldData[field.slug].lat && fieldData[field.slug].lng">
        <a :href="`https://www.google.com/maps?q=${fieldData[field.slug].lat},${fieldData[field.slug].lng}`" target="_blank">
          Zobraziť v Google Maps
        </a>
      </template>
    </div>
  </a-form-item>
</div>

                                            <div   v-if="(field.type === '13' && field.multi === '1')">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <multi v-if="fieldData[field.slug]" :data="{'item.multiplier' :JSON.parse(fieldData[field.slug]) }"  multiplier="true" :options="options[field.id]" :items="['item.multiplier']" :editid="index" @changed="(e) => onChildChangeMulti(e,field.slug)" />
                                                <multi v-else  :items="['item.multiplier']" :options="options[field.id]" :editid="index"  multiplier="false" @changed="(e) => onChildChangeMulti(e,field.slug)"/>
                                              </a-form-item>
                                            </div>
                                            <div   v-if="field.type === '16'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <div v-if="fieldData[field.slug]">
                                                    <div v-for="(fd, index) in fieldData[field.slug]" :key="field.id + index" class="date-row">
                                                        <div v-if="fd" style="margin-left:20px;">
                                                            {{formatDateP(fd[0])}} - {{formatDateP(fd[1])}}
                                                        </div>
                                                        <a-icon class="dynamic-delete-button date-delete" type="minus-circle-o" @click="() => remove(index,field.slug)"/>
                                                    </div>
                                                </div>
                                                <div  class="ant-row-flex"><a-range-picker class="mb-10" :locale="locale" v-model="temp[field.slug]" />

                                                    <a-button type="dashed" class="mb-3" v-if="temp[field.slug]" @click="onChange(temp[field.slug],field.slug)">
                                                        <a-icon type="plus" /> Pridať
                                                    </a-button>
                                                </div>
                                                </a-form-item>
                                            </div>
                                            <div class="mb-3" v-if="field.type === '14'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <a-date-picker v-model="fieldData[field.slug]" v-if="fieldData[field.slug]"  style="width: 100%" :defaultValue="formatDateX(fieldData[field.slug])" :locale="locale" />
                                                <a-date-picker v-model="fieldData[field.slug]"  v-else style="width: 100%" :locale="locale" />
                                                </a-form-item>
                                            </div>
                                            <div class="mb-3" v-if="field.type === '15'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <multi v-if="fieldData[field.slug]" :data="JSON.parse(fieldData[field.slug])" :slug="field.slug" multiplier="false" :items="['title','text']" :editid="index" @changed="(e) => onChildChangeMultiP(e,field.slug)"/>
                                                <multi v-else  :items="['title','text']"  :editid="index" :slug="field.slug"  multiplier="false" @changed="(e) => onChildChangeMultiP(e[field.slug],field.slug)"/>
                                                  </a-form-item>
                                            </div>
                                            <div class="mb-3" v-if="( field.type === '12' && field.multi === '0')">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                              <!---     <autoComplete slug="taxonomysearch" :data="options[field.id]" :contractor="contexts[field.id]"  :title="field.title" class="autoitem" @changed="(e) => onChildTaxChange(e,field.slug)"></autoComplete> -->
                                                <a-select show-search :filter-option="(e,f) => compareData(e,f,field.id)" defaultValue="1"  style="width: 100%"  v-model="fieldData[field.slug]">
                                                    <a-select-option :value="0">Bez priradenia</a-select-option>
                                                    <template v-if="options">
                                                    <a-select-option v-for="op in options[field.id]" :key="op.value">{{op.label}}</a-select-option>
                                                    </template>
                                                </a-select>
                                                <div class="mb-2">
                                                  <a-button @click="addTerm(field)" class="mr-1">+ pridať termín</a-button>

                                                     <template v-if="permissions">
 <template v-if="permissions.includes('showtermshowvoc')">
                                                  <span v-if="fieldData[field.slug]"><router-link :to="'/edit-taxonomy-item/' + fieldData[field.slug] + '/' + contexts[field.id]"><a-button class="mr-1">upraviť termín</a-button></router-link></span>
                                                  <span v-if="fieldData[field.slug]"><router-link :to="'/taxonomy-items/' + contexts[field.id]"><a-button>zobraziť slovník</a-button></router-link></span>
                                                    </template>
                                                  </template>
                                                  <span v-if="fieldData[field.slug]"><router-link :to="'/content/' + cttt + '?filter_' + field.id + '=' + fieldData[field.slug]"><a-button class="mr-1">filtrovať podobné</a-button></router-link></span>
                                                </div>
                                                </a-form-item>
                                            </div>
                                            <div  class="mb-3" v-if="field.type === '8' && field.multi !== '1'">

                                              <a-form-item :label="field.title" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <a-select style="width: 100%" @change="(e) => onChildChange(e,field.slug)"  v-model="fieldData[field.slug]"  placeholder="Vyberte si zo zoznamu">
                                                    <a-select-option value="" key="">Nezvolené</a-select-option >
                                                    <a-select-option v-for="op in options[field.id]"  :value="+op.value" :key="op.value">{{op.label}}</a-select-option >
                                                </a-select>

                                                <template v-if="fieldData[field.slug]">
                                                  <template v-if="fieldData[field.slug] && fieldData[field.slug + '_datax']">
                                                    <div v-if="fieldData[field.slug + '_datax'][fieldData[field.slug]]">
                                                      {{ Object.values(fieldData[field.slug + '_datax'][fieldData[field.slug]]).join(' ') }}
                                                    </div>
                                                  </template>
                                                    <div v-else>{{  fieldData[field.slug + '_data'] }}</div>
                                                  </template>
                                                <template v-if="fieldData[field.slug]"><a-button class="mr-2" @click="getCTdetail(false,fieldData[field.slug])">detail položky</a-button></template>
                                                <span v-if="fieldData[field.slug]">
                                                  <router-link :to="'/edit-content/' + fieldData[field.slug]"><a-button class="mr-2" >upraviť položku</a-button></router-link>
                                                </span>
                                                <a-button @click="assignType(context[field.id],field)">
                                                  <template v-if="fieldData[field.slug]">zmeniť položku</template>
                                                  <template v-else>+ pridať položku</template></a-button>

                                              </a-form-item>
                                            </div>
                                            <div class="mb-3" v-if="field.type === '9'">
                                                <div v-if="field.slug === 'city'">
                                                    <label class="form-control-label">{{field.title}}:</label>
                                                    <div v-if="Array.isArray(fieldData[field.slug])">{{fieldData[field.slug][1]}}</div>

                                                    <a-auto-complete
                                                            v-model="fieldData[field.slug]" :dataSource="options[field.id]" @select="(e) => onSelect(e,field.slug)" @search="(e) => onSearch(e,field.id)">   <template slot="dataSource">
                                                        <a-select-option v-for="item in dataSource" :key="item.value" :title="item.text"></a-select-option>
                                                    </template>
                                                    </a-auto-complete>
                                                </div>
                                                <div v-if="field.slug === 'beecount'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">

                                                   <a-row class="w-100" gutter="12" v-if="fieldData[field.slug]">
                                                    <a-col :span="4">
                                                    <a-form-item label="Počet">
                                                    <a-input-number class="w-100" v-model="fieldData[field.slug].count"/>
                                                    </a-form-item>
                                                    </a-col>
                                                    <a-col :span="18">
                                                     <a-form-item label="Hodnota platná od" >
                                                      <a-date-picker v-model="fieldData[field.slug].validFrom" :locale="locale2"  /></a-form-item>
                                                    </a-col>
                                                    </a-row>
                                                    </a-form-item>
                                                </div>

                                            </div>
                                            <div class="mb-3" v-if="field.type === '8' && field.multi === '1'">

                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                              <a-button style="position: absolute; right: 17px; top: 0;" size="small" @click="addContent(field.id,field.title)">+ pridať</a-button>
                                                <a-select v-if="fieldData[field.slug]"
                                                   :filter-option="(e,f) => compareData(e,f,field.id)"
                                                   mode="multiple" style="width: 100%"  v-model="fieldData[field.slug]" placeholder="Vyberte si z možností">
                                                  <template v-if="options">
                                                    <a-select-option v-for="op in options[field.id]" :key="op.value">{{op.label}}</a-select-option>
                                                  </template>
                                                </a-select>

                                               <a-select v-else
                                                          mode="multiple"
                                                          :filter-option="(e,f) => compareData(e,f,field.id)"
                                                          style="width: 100%"
                                                          @change="(e) => onChildChange(e,field.slug)"
                                                          placeholder="Vyberte si z možností"
                                                >
                                                <template v-if="options">
                                                    <a-select-option v-for="op in options[field.id]" :key="op.value">{{op.label}}</a-select-option
                                                    >
                                                    </template>

                                                </a-select>

</a-form-item>
                                            </div>
<!-- HISTÓRIA NUMERICKÝCH POLÍ -->
<template v-if="field.historic == '1' && (field.type === '5' || field.type === '6')">
  <a-row>
    <a-col :span="labelCol.span"></a-col>
    <a-col :span="wrapperCol.span">
      <div class="mb-1 font-weight-bold">História hodnoty</div>

      <table v-if="historic[field.slug] && historic[field.slug].length"
             class="w-100 table table-sm">
        <thead>
          <tr>
            <th style="width:130px;">Dátum</th>
            <th style="width:130px;">Hodnota</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in historic[field.slug]"
              :key="row.id">
            <td>{{ formatDateS(row.valid_from || row.date) }}</td>
            <td>{{ row.value }}</td>
            <td class="text-right">
              <a-button size="small" @click="editHistoric(field.slug, row)">Upraviť</a-button>
              <a-popconfirm
                title="Naozaj chcete zmazať tento záznam?"
                ok-text="Áno"
                cancel-text="Nie"
                @confirm="deleteHistoric(field.slug, row.id)"
              >
                <a-button size="small" class="ml-1">Zmazať</a-button>
              </a-popconfirm>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-else class="text-muted small mb-2">
        Zatiaľ neexistujú žiadne historické záznamy.
      </div>

      <a-button size="small" type="dashed" class="mb-3"
        @click="openHistoricModal(field.slug, fieldData[field.slug])">
        + Pridať záznam
      </a-button>
    </a-col>
  </a-row>
</template>





                                            <div class="mb-3" v-if=" field.type === '12' && field.multi === '1'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <a-select v-if="fieldData[field.slug]"
                                                          mode="multiple" style="width: 100%" :defaultValue = "JSON.parse(fieldData[field.slug])"
                                                          @change="(e) => onChildChange(e,field.slug)" placeholder="Vyberte si z možností">
                                                          <template v-if="options">
                                                    <a-select-option v-for="op in options[field.id]" :key="op.value">{{op.label}}</a-select-option>
                                                    </template>
                                                </a-select>

                                                <a-select v-else
                                                          mode="multiple"
                                                          style="width: 100%"
                                                          @change="(e) => onChildChange(e,field.slug)"
                                                          placeholder="Vyberte si z možností"
                                                >
                                                <template v-if="options">
                                                    <a-select-option v-for="op in options[field.id]" :key="op.value">{{op.label}}</a-select-option
                                                      >
                                                      </template>
                                                </a-select>
                                              </a-form-item>
                                            </div>


                                            <template v-if="field.schedulable == 1 && field.historical">
                                                <a-row> <a-col :span="labelCol.span"></a-col> <a-col :span="wrapperCol.span">
  <span v-if="field.nextvalues" class="mr-1" title="Naplánovaná zmena" @click="showschedule(field)"><i class="far fa-clock"></i></span>
  <template v-else><span v-if="field.historical" @click="showschedule(field)" class="mr-1" title="História položky"><a-button>História položky</a-button></span></template>
<a-button v-if="field.schedulable" class="mb-4" @click="fieldSetup(field)">Naplánovať hodnotu</a-button>
</a-col>
                                </a-row>
                                </template>

<template v-if="field.schedulable != 1 && field.historical">
   <a-row> <a-col :span="labelCol.span" class="text-right"></a-col> <a-col :span="wrapperCol.span">
    <div class="mb-3" title="Predchádzajúce hodnoty">Predchádzajúce hodnoty</div>
      <table class="w-100 table small">
    <thead><tr><th style="width:220px;">Hodnota</th><th>Platná do</th></tr></thead>
    <tbody>
    <template v-for="next in field.historical">
<tr :key="next.id + 'nextv'" class="p-1"><td><template v-if="field.type != '50' && field.type != '9'">{{ next.value }}</template>
<template v-else>

      <template v-if="field.type == '9'">
        <template v-if="next.value">
        {{formatDateS(JSON.parse(next.value).validFrom)}} - {{JSON.parse(next.value).count}}
        </template>
      </template>

      <template v-if="next.value[producttype]">
        <a-col :span="4" >{{ next.value[producttype].unit }}</a-col>
        <a-col :span="4" > {{ next.value[producttype].tax }}</a-col>
      </template>

</template>
</td><td>{{ formatDatedJD(next.dateto) }}</td></tr>
    </template>
  </tbody>
  </table>
</a-col>
                                </a-row>
  </template>
</div>
                                    </div>
                                </div>
                        </template>

                            </a-tab-pane>
                            </template>

                            <template v-if="hasBuilder"> <a-tab-pane key="112" tab="BetaEditor">
                              <betaeditor :id="id" :ct="cttt" :vars="vars" :values="fieldData.builder" :lang="fieldData.language" data="builder" :key="refreshAll" :url="vars.site_url + '/' + fieldData.language + '/' + fieldData.url" @changed="(ee) => onChildChangeBuilder(ee,'builder')"></betaeditor>

                              </a-tab-pane></template>

                            <template v-if="priceStats && priceStats.history && priceStats.history.length > 0">
                              <a-tab-pane key="pricestats" tab="Cenový vývoj">
                                <div class="price-stats-panel">
                                  <div class="price-stats-header mb-3">
                                    <span class="text-muted mr-2">Obdobie:</span>
                                    <a-radio-group v-model="priceStatsDays" size="small" @change="fetchPriceStats(priceStatsDays)">
                                      <a-radio-button :value="7">7 dní</a-radio-button>
                                      <a-radio-button :value="14">14 dní</a-radio-button>
                                      <a-radio-button :value="30">30 dní</a-radio-button>
                                      <a-radio-button :value="90">90 dní</a-radio-button>
                                    </a-radio-group>
                                    <span class="ml-3" v-if="priceStats.product">
                                      Naša cena: <strong>{{ formatPrice(priceStats.product.current_price) }}</strong>
                                    </span>
                                  </div>
                                  <a-spin v-if="priceStatsLoading" />
                                  <div v-else>
                                    <div class="price-chart-wrapper mb-3" v-if="priceChartDatasets.length">
                                      <CChartLine :datasets="priceChartDatasets" :options="priceChartOptions" :labels="priceChartLabels" style="height:250px;" />
                                    </div>
                                    <div class="table-responsive">
                                      <table class="price-stats-table">
                                        <thead>
                                          <tr>
                                            <th>Dátum</th>
                                            <th>Naša cena</th>
                                            <template v-for="(ch, chKey) in priceStats.history[0].channels">
                                              <th :key="'h-'+chKey" colspan="2">{{ channelLabel(chKey) }}</th>
                                            </template>
                                          </tr>
                                          <tr class="price-stats-subheader">
                                            <th></th><th></th>
                                            <template v-for="(ch, chKey) in priceStats.history[0].channels">
                                              <th :key="'hl-'+chKey">Najnižšia</th>
                                              <th :key="'hh-'+chKey">Najvyššia</th>
                                            </template>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(row, ri) in priceStats.history" :key="'pr-'+ri">
                                            <td class="text-muted">{{ formatDateP(row.date) }}</td>
                                            <td>{{ formatPrice(row.our_price) }}</td>
                                            <template v-for="(ch, chKey) in row.channels">
                                              <td :key="'l-'+chKey+ri" :class="priceStatsDiffClass(ch.diff_lowest)">
                                                <template v-if="ch.lowest !== null">{{ formatPrice(ch.lowest) }}<span class="price-diff">{{ formatDiff(ch.diff_lowest) }}</span></template>
                                                <template v-else><span class="text-muted">—</span></template>
                                              </td>
                                              <td :key="'hg-'+chKey+ri" :class="priceStatsDiffClass(ch.diff_highest)">
                                                <template v-if="ch.highest !== null">{{ formatPrice(ch.highest) }}<span class="price-diff">{{ formatDiff(ch.diff_highest) }}</span></template>
                                                <template v-else><span class="text-muted">—</span></template>
                                              </td>
                                            </template>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </a-tab-pane>
                            </template>
<template v-if="hasMultiDocuments">
  <a-tab-pane key="1919" tab="Dokumenty">
    <template v-if="!pdfPreviewActive">
    <template v-for="(group, gid) in contenttype.groups">
      <span :key="gid" :tab="group.name" v-if="group.child.length">
        <template>
          <div class="pl-4 pr-4">
            <div class="row">
              <div class="col-lg-12" :key="index" v-for="(field, index) in group.child">
                <div class="mb-3" v-if="field.type === '19' && field.multi === '1'">
                  <a-form-item :label="field.title" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <div class="d-flex justify-content-between">
                      <a-button type="primary" @click="openNewDocumentModal(field.slug)" class="mb-3">
                        <i class="far fa-plus-square mr-2"></i> Nový dokument
                      </a-button>
                      <a-button type="default" @click="downloadAllApprovedDocuments(field.slug)">
                        <i class="fas fa-file-archive mr-2"></i>Stiahnuť všetky schválené
                      </a-button>
                    </div>
                    <div
  v-for="(doc, docIndex) in fieldData[field.slug]"
  :key="'doc_' + docIndex"
  class="document-block border rounded pt-3 pl-3 pr-3 pb-0 mb-3 w-100"
 :class="{
  'border-danger': doc.versions && doc.versions.length && doc.versions[doc.versions.length - 1].status === 'rejected',
  'border-warning': doc.versions && doc.versions.length && doc.versions[doc.versions.length - 1].status === 'new',
  'border-info': doc.versions && doc.versions.length && doc.versions[doc.versions.length - 1].status === 'repair'
}" >

                      <div class="d-flex justify-content-between align-items-start flex-wrap w-100">
                        <div class="flex-grow-1">
                          <div>
                            <div class="float-right mt-2 mt-sm-0">
                              <template v-if="doc.versions && doc.versions.length > 1">
                                <a-button size="small" type="default" @click="toggleVersions(field.slug, docIndex)">
                                  <template v-if="expandedVersions[field.slug + '_' + docIndex]">Skryť verzie</template>
                                  <template v-else>Zobraziť verzie</template>
                                </a-button>
                              </template>
                              <a-popconfirm
                                title="Naozaj chcete zmazať celý dokument vrátane všetkých verzií?"
                                ok-text="Áno"
                                cancel-text="Nie"
                                @confirm="removeDocument(field.slug, docIndex)"
                              >
                                <a-button type="default" size="small" class="ml-2">
                                  <i class="far fa-trash-alt mr-1"></i>Zmazať dokument
                                </a-button>
                              </a-popconfirm>
                              <a-upload :customRequest="(e) => uploadVersion(field.slug, docIndex, e)" :showUploadList="false">
                                <a-button type="dashed" size="small" class="ml-2">+ Nahrať novú verziu</a-button>
                              </a-upload>
                            </div>
                            <div :class="(!doc.description ? 'descripion-minheight no-description' : 'descripion-minheight')">
                              <h5 class="mb-0">{{ doc.name }}</h5>
                              <div class="text-muted mb-0" v-if="doc.description">{{ doc.description }}</div>
                            </div>
                          </div>
                          <div v-if="doc.versions && doc.versions.length" class="mb-2">
                            <div class="d-flex align-items-start justify-content-between flex-wrap w-100">
                            <div :key="doc.versions[doc.versions.length - 1].status"
                                  class="version-box d-flex align-items-center pl-2 rounded"
                                  :class="{
                                    'text-success': doc.versions[doc.versions.length - 1].status === 'approved',
                                    'text-warning': doc.versions[doc.versions.length - 1].status === 'new',
                                    'text-info': doc.versions[doc.versions.length - 1].status === 'repair',
                                    'text-danger': doc.versions[doc.versions.length - 1].status === 'rejected'
                                  }">
                                <span class="mr-2">
                                  <i :class="{
                                      'fas fa-check': doc.versions[doc.versions.length - 1].status === 'approved',
                                      'fas fa-question': doc.versions[doc.versions.length - 1].status === 'new',
                                      'fas fa-times': doc.versions[doc.versions.length - 1].status === 'rejected',
                                      'fas fa-wrench': doc.versions[doc.versions.length - 1].status === 'repair' }"
                                  ></i>
                                </span>
                                <div>
                                  {{ doc.versions[doc.versions.length - 1].filename }}
                                  <span class="text-muted small">(v{{ doc.versions.length }})</span>
                                <span
  class="badge badge-info ml-2"
  v-if="(field.slug + '_' + docIndex) === latestDocumentKey"
>
  Najnovší
</span>
                                </div>
                              </div>
                              <div class="d-flex align-items-center mt-2 mt-sm-0">
                                <span class="text-muted small mr-3">
                                 {{doc.versions[doc.versions.length - 1].uploaderName}} - {{ formatDateX(doc.versions[doc.versions.length - 1].uploaded_at) }}
                                </span>
                                <a-select
                                  size="small"
                                  v-model="doc.versions[doc.versions.length - 1].status"
                                  style="width: 130px"
                                  class="mr-2"
                                  @change="handleAutoSave(field.slug)"
                                >
                                  <a-select-option value="new">Nový</a-select-option>
                                  <a-select-option value="approved">Schválený</a-select-option>
                                  <a-select-option value="repair">Na opravu</a-select-option>
                                  <a-select-option value="rejected">Zamietnutý</a-select-option>
                                </a-select>
                                <a-button size="small" class="ml-2" @click="previewFile(doc.versions[doc.versions.length - 1].fid, field.slug, docIndex, doc.name,doc.versions[doc.versions.length - 1].uri)"><i class="far fa-eye mr-1"></i>Zobraziť</a-button>
                                <a-button size="small" class="ml-2" @click="downloadFile(doc.versions[doc.versions.length - 1].uri)"><i class="fas fa-download mr-1"></i>Stiahnuť</a-button>
                                <a-button size="small" class="ml-2" @click="removeVersion(field.slug, docIndex, doc.versions.length - 1)"><i class="far fa-trash-alt mr-1"></i>Zmazať</a-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="expandedVersions[field.slug + '_' + docIndex]" class="mt-0">
                        <hr class="m-0" />
                        <h6 class="pl-2 pt-2 mb-0 pb-0">Predchádzajúce verzie</h6>
                        <div
                          v-for="(ver, vIndex) in doc.versions.slice(0, -1)"
                          :key="ver.fid"
                          class="d-flex align-items-center justify-content-between mb-2 w-100"
                        >
                          <div class="d-flex align-items-center">
                            <div class="version-box d-flex align-items-center p-2 rounded">
                              <span class="mr-2">
                                <i class="fas fa-file-alt"></i>
                              </span>
                              <div>{{ ver.filename }} <span class="text-muted small">(v{{ vIndex + 1 }})</span>
                                <span class="badge badge-secondary small ml-2 text-capitalize">
                                  <template v-if="ver.status === 'new'">Nový</template>
                                  <template v-else-if="ver.status === 'approved'">Schválený</template>
                                  <template v-else-if="ver.status === 'repair'">Potrebná oprava</template>
                                  <template v-else-if="ver.status === 'rejected'">Zamietnutý</template>
                                  <template v-else>Neznámy</template>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex align-items-center mt-2 mt-sm-0">
                            <span class="text-muted small mr-3">
                              {{ver.uploaderName}} - {{ formatDateX(ver.uploaded_at) }}
                            </span>
                            <a-button size="small" class="ml-2" @click="previewFile(ver.fid,field.slug, docIndex, doc.name,ver.uri)"><i class="far fa-eye mr-1"></i>Zobraziť</a-button>
                            <a-button size="small" class="ml-2" @click="downloadFile(ver.uri)"><i class="fas fa-download mr-1"></i>Stiahnuť</a-button>
                            <a-popconfirm
  title="Naozaj chcete zmazať túto verziu dokumentu?"
  ok-text="Áno"
  cancel-text="Nie"
  @confirm="removeVersion(field.slug, docIndex, vIndex)">
  <a-button size="small" class="ml-2">
    <i class="far fa-trash-alt mr-1"></i>Zmazať
  </a-button>
</a-popconfirm>

                          </div>
                        </div>
                      </div>
                    </div>
                  </a-form-item>
                </div>
              </div>
            </div>
          </div>
        </template>
      </span>
    </template>
    </template>
    <template v-else>
   <PdfViewer
         v-if="pdfMode && pdfResolvedUrl"
    :src="pdfResolvedUrl"
  :fid="pdfPreviewData.fid"
  :title="pdfPreviewData.title"
  :slug="pdfPreviewData.slug"
  :doc-index="pdfPreviewData.docIndex"
  v-model="comments"
  @update:comments="handleCommentsUpdate"
  @close="pdfPreviewActive = false"
  />


  <ImageViewer
    v-if="!pdfMode"
      :src="pdfPreviewData.uri"
  :fid="pdfPreviewData.fid"
  :title="pdfPreviewData.title"
  :slug="pdfPreviewData.slug"
  :doc-index="pdfPreviewData.docIndex"
  v-model="comments"
  @update:comments="handleCommentsUpdate"
  @close="pdfPreviewActive = false"
  />

</template>
  </a-tab-pane>
</template>





                              <template v-if="hasProductOptions && hasAnyProductRelation">
                                <a-tab-pane key="113" tab="Produktové vzťahy">
                                  <div class="pl-4 pr-4 pt-3">

                                    <a-tabs size="small" :default-active-key="defaultProductRelationTab" tab-position="left" class="mb-4">

                                      <a-tab-pane key="rel-variants" :tab="'Varianty (' + (productRelations ? (productRelations.variants ? productRelations.variants.length : 0) + (productRelations.parent ? 1 : 0) : 0) + ')'">
                                        <div class="mb-2 text-right"><a-button size="small" @click="openProductRelationSearch('variants')"><i class="fas fa-plus pr-1"></i>Pridať variant</a-button></div>

                                        <!-- Hlavný produkt ako prvý riadok -->
                                        <div v-if="productRelations && productRelations.parent" class="product-relation-item">
                                          <img :src="productRelations.parent.image || productRelationImageFallback" class="product-relation-thumb" />
                                          <div class="product-relation-info">
                                            <strong>{{ productRelations.parent.title }}</strong>
                                            <a-tag color="blue" class="ml-2">Hlavný produkt</a-tag>
                                            <div class="text-muted small" v-if="productRelations.parent.attributes && productRelations.parent.attributes.length">
                                              <span v-for="(attr, ati) in productRelations.parent.attributes" :key="'pattr-'+ati">{{ attr.type }}: {{ attr.value }}<span v-if="ati < productRelations.parent.attributes.length - 1"> · </span></span>
                                            </div>
                                          </div>
                                          <div class="product-relation-price" v-if="productRelations.parent.price">{{ Number(productRelations.parent.price).toFixed(2) }} €</div>
                                          <a-popconfirm placement="topRight" okText="Áno, prejsť" cancelText="Zrušiť" @confirm="$router.push('/edit-content/' + productRelations.parent.id)">
                                            <template slot="title">Neuložené zmeny budú stratené. Pokračovať?</template>
                                            <a-button size="small">Upraviť</a-button>
                                          </a-popconfirm>
                                        </div>

                                        <template v-if="productRelations && productRelations.variants && productRelations.variants.length">
                                          <div v-for="(v, vi) in productRelations.variants" :key="'var-'+v.id" class="product-relation-item">
                                            <img :src="v.image || (productRelations.parent && productRelations.parent.image) || productRelationImageFallback" class="product-relation-thumb" />
                                            <div class="product-relation-info">
                                              <strong>{{ v.title }}</strong>
                                              <div class="text-muted small" v-if="v.attributes && v.attributes.length">
                                                <span v-for="(attr, ati) in v.attributes" :key="'attr-'+ati">{{ attr.type }}: {{ attr.value }}<span v-if="ati < v.attributes.length - 1"> · </span></span>
                                              </div>
                                              <div class="text-muted small" v-if="v.description">{{ v.description }}</div>
                                            </div>
                                            <div class="product-relation-price" v-if="v.price">{{ Number(v.price).toFixed(2) }} €</div>
                                            <a-popconfirm placement="topRight" okText="Áno, prejsť" cancelText="Zrušiť" @confirm="$router.push('/edit-content/' + v.id)">
                                              <template slot="title">Neuložené zmeny budú stratené. Pokračovať?</template>
                                              <a-button size="small">Upraviť</a-button>
                                            </a-popconfirm>
                                            <a-button size="small" type="link" style="color:red;" @click="removeProductRelation('variants', vi)"><i class="fas fa-times"></i></a-button>
                                          </div>
                                        </template>
                                        <div v-else-if="!productRelations || !productRelations.parent" class="text-muted p-2">Žiadne podprodukty</div>
                                      </a-tab-pane>

                                      <a-tab-pane key="rel-configurable" :tab="'Konfigurovateľné (' + (productRelations && productRelations.configurable ? productRelations.configurable.length : 0) + ')'">
                                        <div class="mb-2 text-right"><a-button size="small" @click="openProductRelationSearch('configurable')"><i class="fas fa-plus pr-1"></i>Pridať</a-button></div>
                                        <template v-if="productRelations && productRelations.configurable && productRelations.configurable.length">
                                          <div v-for="(c, ci) in productRelations.configurable" :key="'cfg-'+c.id" class="product-relation-item">
                                            <img :src="c.image || productRelationImageFallback" class="product-relation-thumb" />
                                            <div class="product-relation-info">
                                              <strong>{{ c.title }}</strong>
                                              <div class="text-muted small" v-if="c.description">{{ c.description }}</div>
                                            </div>
                                            <div class="product-relation-price" v-if="c.price">{{ Number(c.price).toFixed(2) }} €</div>
                                            <a-popconfirm placement="topRight" okText="Áno, prejsť" cancelText="Zrušiť" @confirm="$router.push('/edit-content/' + c.id)">
                                              <template slot="title">Neuložené zmeny budú stratené. Pokračovať?</template>
                                              <a-button size="small">Upraviť</a-button>
                                            </a-popconfirm>
                                            <a-button size="small" type="link" style="color:red;" @click="removeProductRelation('configurable', ci)"><i class="fas fa-times"></i></a-button>
                                          </div>
                                        </template>
                                        <div v-else class="text-muted p-2">Žiadne konfigurovateľné produkty</div>
                                      </a-tab-pane>

                                      <a-tab-pane key="rel-accessories" :tab="'Príslušenstvo (' + (productRelations && productRelations.accessories ? productRelations.accessories.length : 0) + ')'">
                                        <div class="mb-2 text-right"><a-button size="small" @click="openProductRelationSearch('accessories')"><i class="fas fa-plus pr-1"></i>Pridať</a-button></div>
                                        <template v-if="productRelations && productRelations.accessories && productRelations.accessories.length">
                                          <template v-for="(group, sortiment) in accessoriesBySortiment">
                                            <div :key="'sort-'+sortiment" class="accessories-group">
                                              <div class="accessories-group-title">{{ sortiment }}</div>
                                              <div v-for="(a, ai) in group" :key="'acc-'+a.id" class="product-relation-item">
                                                <img :src="a.image || productRelationImageFallback" class="product-relation-thumb" />
                                                <div class="product-relation-info">
                                                  <strong>{{ a.title }}</strong>
                                                  <div class="text-muted small">
                                                    <span v-if="a.brand">{{ a.brand }}</span>
                                                    <span v-if="a.brand && a.description"> · </span>
                                                    <span v-if="a.description">{{ a.description }}</span>
                                                  </div>
                                                </div>
                                                <div class="product-relation-price" v-if="a.price">{{ Number(a.price).toFixed(2) }} €</div>
                                                <a-popconfirm placement="topRight" okText="Áno, prejsť" cancelText="Zrušiť" @confirm="$router.push('/edit-content/' + a.id)">
                                                  <template slot="title">Neuložené zmeny budú stratené. Pokračovať?</template>
                                                  <a-button size="small">Upraviť</a-button>
                                                </a-popconfirm>
                                                <a-button size="small" type="link" style="color:red;" @click="removeProductRelation('accessories', productRelations.accessories.indexOf(a))"><i class="fas fa-times"></i></a-button>
                                              </div>
                                            </div>
                                          </template>
                                        </template>
                                        <div v-else class="text-muted p-2">Žiadne príslušenstvo</div>
                                      </a-tab-pane>

                                      <a-tab-pane key="rel-used-as" :tab="'Príslušenstvo k (' + (productRelations && productRelations.usedAsAccessoryIn ? productRelations.usedAsAccessoryIn.length : 0) + ')'">
                                        <template v-if="productRelations && productRelations.usedAsAccessoryIn && productRelations.usedAsAccessoryIn.length">
                                          <div v-for="p in productRelations.usedAsAccessoryIn" :key="'ua-'+p.id" class="product-relation-item">
                                            <img :src="p.image || productRelationImageFallback" class="product-relation-thumb" />
                                            <div class="product-relation-info">
                                              <strong>{{ p.title }}</strong>
                                              <div class="text-muted small" v-if="p.description">{{ p.description }}</div>
                                            </div>
                                            <div class="product-relation-price" v-if="p.price">{{ Number(p.price).toFixed(2) }} €</div>
                                            <a-popconfirm placement="topRight" okText="Áno, prejsť" cancelText="Zrušiť" @confirm="$router.push('/edit-content/' + p.id)">
                                              <template slot="title">Neuložené zmeny budú stratené. Pokračovať?</template>
                                              <a-button size="small">Upraviť</a-button>
                                            </a-popconfirm>
                                          </div>
                                        </template>
                                        <div v-else class="text-muted p-2">Tento produkt nie je priradený ako príslušenstvo k žiadnemu produktu</div>
                                      </a-tab-pane>

                                      <a-tab-pane key="rel-combos" :tab="'Kombinácie (' + (fieldData.rows ? fieldData.rows.length : 0) + ')'" v-if="fieldData.rows && fieldData.rows.length">
                                        <table class="slim w-100 table tablesorter productCombo">
                                          <tr>
                                            <th width="40%">Kombinácia</th>
                                            <th>Obrázok</th>
                                            <th></th>
                                          </tr>
                                          <template v-for="(row, rowIndex) in fieldData.rows">
                                            <tr :key="rowIndex">
                                              <td>
                                                <template v-for="(category, iio) in productOptionsCategories">
                                                  <div :key="iio">
                                                    <a-form-item :label="category">
                                                      <a-select v-model="row.selectedOptions[iio]">
                                                        <template v-for="af in productOptions">
                                                          <a-select-option v-if="af.category == iio" :key="af.produktId2.id" :value="af.produktId2.id">
                                                            {{ af.produktId2.title }} - {{af.produktId2.atribute_data}}
                                                          </a-select-option>
                                                        </template>
                                                      </a-select>
                                                    </a-form-item>
                                                  </div>
                                                </template>
                                              </td>
                                              <td>
                                                <image-upload :data="row.image" :dat="rowIndex" @changed="updateImage(rowIndex, $event)"></image-upload>
                                              </td>
                                              <td>
                                                <a-button @click="removeRow(rowIndex)">Odobrať</a-button>
                                              </td>
                                            </tr>
                                          </template>
                                        </table>
                                        <div class="text-left">
                                          <a-button @click="addRow">Pridať kombináciu</a-button>
                                          <a-button @click="fillAllCombinations">Vyplniť všetky kombinácie</a-button>
                                        </div>
                                      </a-tab-pane>

                                    </a-tabs>
                                  </div>
                                </a-tab-pane>
                              </template>



                        </a-tabs>


                        </a-card>
   <a-card class="history-card mt-3" :loading="saving" v-if="created">
<span slot="title">Podrobnosti</span>
<a-tabs  default-active-key="history" :tab-position="detailTabPosition">
  <a-tab-pane key="history" tab="História">

  <div style="max-height:300px;overflow-y:auto;">
      <table class="history-table w-100">
        <tbody>
          <tr v-for="item in history" :key="item.id || item.created">
            <td class="history-action">{{historyState[item.action]}}</td>
            <td class="history-meta text-muted text-nowrap" style="text-align:right">{{item.user}}</td>
            <td class="history-date text-muted text-nowrap" style="text-align:right">{{formatDateX(item.created)}}</td>
            <td class="history-btn text-right text-nowrap">
              <a-button v-if="item.id" size="small" :loading="restoringHistoryId === item.id" @click="previewHistory(item)"><i class="fas fa-history pr-1"></i>Porovnať</a-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    </a-tab-pane>
  <a-tab-pane key="statistics" tab="Štatistika" v-if="nodeStats && nodeStats.length > 0">

           <CChartLine
    :datasets="computedDatasets"
    :options="defaultOptions"
    :labels="computedLabels"
  />

    </a-tab-pane>
  </a-tabs>


      </a-card>

<a-modal
  v-model="historyDiffVisible"
  :title="'Porovnanie — ' + (historyDiffMeta.user || '') + ' · ' + (historyDiffMeta.date || '')"
  width="90%"
  :footer="null"
  :bodyStyle="{ maxHeight: '70vh', overflowY: 'auto', padding: '16px' }"
>
  <a-spin v-if="historyDiffLoading" class="d-block text-center p-4" />
  <template v-else-if="historyDiffFields.length">
    <a-alert type="info" class="mb-3" message="Zobrazené sú len polia, ktoré sa líšia. Kliknite Obnoviť pre načítanie zálohy do formulára (bez uloženia)." />
    <div class="mb-3" v-if="historyDiffHasBuilder">
      <a-radio-group v-model="historyDiffViewMode" size="small">
        <a-radio-button value="text">Zdrojový kód</a-radio-button>
        <a-radio-button value="preview">Ukážka</a-radio-button>
      </a-radio-group>
    </div>
    <table class="history-diff-table">
      <thead>
        <tr>
          <th style="width:15%">Pole</th>
          <th style="width:42%">Aktuálny stav</th>
          <th style="width:42%">Záloha</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="d in historyDiffFields">
          <tr v-if="d.key === 'builder'" :key="d.key" class="diff-row-changed">
            <td class="font-weight-bold">{{ d.label }}</td>
            <td class="diff-current" colspan="1">
              <div v-if="historyDiffViewMode === 'preview'" class="diff-preview-frame">
                <iframe v-if="historyDiffPreviewCurrent" :srcdoc="historyDiffPreviewCurrent" class="diff-iframe"></iframe>
                <a-spin v-else />
              </div>
              <div v-else class="diff-cell"><pre class="diff-pre">{{ d.currentRaw }}</pre></div>
            </td>
            <td class="diff-backup" colspan="1">
              <div v-if="historyDiffViewMode === 'preview'" class="diff-preview-frame">
                <iframe v-if="historyDiffPreviewBackup" :srcdoc="historyDiffPreviewBackup" class="diff-iframe"></iframe>
                <a-spin v-else />
              </div>
              <div v-else class="diff-cell"><pre class="diff-pre">{{ d.backupRaw }}</pre></div>
            </td>
          </tr>
          <tr v-else :key="d.key" class="diff-row-changed">
            <td class="font-weight-bold">{{ d.label }}</td>
            <td class="diff-current"><div class="diff-cell" v-html="d.currentHtml"></div></td>
            <td class="diff-backup"><div class="diff-cell" v-html="d.backupHtml"></div></td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="text-right mt-3">
      <a-button @click="historyDiffVisible = false" class="mr-2">Zavrieť</a-button>
      <a-button type="primary" @click="applyHistoryRestore"><i class="fas fa-undo pr-1"></i>Obnoviť tento stav</a-button>
    </div>
  </template>
  <template v-else>
    <a-alert type="success" message="Žiadne rozdiely — aktuálny stav je zhodný so zálohou." />
  </template>
</a-modal>

<a-modal
  v-model="historicModalVisible"
  :title="currentHistoric.id ? 'Upraviť historický záznam' : 'Nový historický záznam'"
  @ok="saveHistoric"
  @cancel="historicModalVisible = false"
>
  <a-form-item label="Dátum" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
    <a-date-picker
      style="width: 100%"
      v-model="currentHistoric.date"
      :locale="locale2"
      :disabledDate="disableFutureDates"
    />
  </a-form-item>

  <a-form-item label="Hodnota" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
    <a-input-number
      class="w-100"
      v-model="currentHistoric.value"
    />
  </a-form-item>
</a-modal>




        <a-modal :title="'Pridajte obsah: ' + fieldaddtitle" centered  v-model="addContentShow" :width="900" :footer="null" v-if="addContentShow" cancelText="Zrušiť" @cancel="addContentShow = false" okText="Vytvoriť" @ok="addSelect">
        <fields
  :id="fieldtoselect"
  :parent-id="id"
  :parent-ct="ctt"
   :fields="beekeeperFields"
  @change="settheavalue"
/>
        </a-modal>


        <a-modal title="Nový termín" centered  v-model="newTerm" v-if="newTerm" cancelText="Zrušiť" @cancel="newTerm = false" okText="Pridať" @ok="addNewTerm">
            <a-input type="text" v-model="newTermToAdd"></a-input>
        </a-modal>



        <a-modal title="Revízie" centered  v-model="revisionsShow" v-if="revisionsShow" cancelText="Zrušiť" @cancel="revisionsShow = false" okText="Vrátiť" @ok="revert">
            <a-alert class="mb-2" message="Vráti stránku do stavu z nasledujúceho času. Ak chcete zmeny uložiť, je potrebné stlačiť Uložiť (alebo použiť CTRL + S)." type="info" />
            <a-select v-model="revision" class="w-100"  placeholder="Vyberte si z predchádzajúcich verzií">
                <a-select-option v-for="op in revisions" :key="op.id">{{op.created}}</a-select-option>
            </a-select>

        </a-modal>

<a-modal v-if="showImages" v-model="showImages" @ok="showImagesDrag">



 <template v-for="(group,gid) in contenttype.groups">
                        <template  v-if="group.child.length">
                        <template>
                        <template v-for="(field, index) in group.child">
                        <div  :key="index" v-if="field.type == 3" class="d-inline-block border-1 w-100">
                        {{field.title}}
                         <a-row :gutter="12"><draggable class="list-group w-100" :data-type="field.type" :list="imagesToAdd[field.slug]"  group="imagess">
                        <template v-for="(im,index) in imagesToAdd[field.slug]">
<a-col :key="im.id" :span="4">
<img :key="index" :src="im.url" class="dgallery-image" />
</a-col>
</template>
                        </draggable>
</a-row>

                        </div>
                         <div  :key="index" v-if="field.type == 11" class="d-inline-block border-1 w-100">
                        {{field.title}}
                         <a-row :gutter="12">
                        <draggable class="list-group w-100"  :list="imagesToAdd[field.slug]"  :move="checkMove" group="imagess">
                        <template v-for="(im,index) in imagesToAdd[field.slug]">
<a-col :key="im.id" :span="4">
<img :key="index" :src="im.url" class="dgallery-image" />
</a-col>
</template>
</draggable>
</a-row>
                        </div>
                        </template>
                        </template>
                        </template>

                        </template>
     <a-row :gutter="12">
     <div class="draggable-galler-image">
     <label>Externé obrázky</label>
 <draggable :list="crawledImages" group="imagess" :move="checkMove">
<template v-for="(im,index) in crawledImages">
<a-col :key="im.id" :span="6">
<img :key="index" :src="im.url" class="dgallery-image" />
</a-col>
</template>
</draggable>
</div>
</a-row>

</a-modal>


      <a-modal v-if="showImportModalImages" v-model="showImportModalImages" @ok="crawlPageImages">
        URL produktu: <a-input v-model="crawlUrl"></a-input>
      </a-modal>

      <a-modal :title="'Vyhľadávanie v položkách: ' + (productSlug == 'specificNodes' ? 'ukáž vybrané' : 'ignoruj vybrané')" :width="1200" centered v-model="productSearch" :footer="false">
      <a-row :gutter="36">
        <a-col :span="8">
<h6>Vybrané položky</h6>
<div :key="rearangablefiles">
<draggable v-bind="dragOptions" v-model="selectedNodes" @change="rearanged" group="newcomponents"  handle=".handle" class="rearange-table">
  <transition-group>
<template v-for="(spn,ind) in selectedNodes">
  <div :key="'spn' + spn.value" class="w-100"><a class="handle mr-2"><i class="fa fa-expand-arrows-alt"></i></a>{{ spn.label }} ({{ spn.value }})
    <a class="float-right" @click="removeItemFrom('specificNodes',ind)">x</a>
    <a class="float-right" @click="getProductDetail(spn.value ? spn.value : spn.key)"><i class="fas fa-eye pr-1"></i></a>
  </div>
</template>
  </transition-group>
  </draggable>
</div>
        </a-col>
     <a-col :span="16">

                 <a-form-item :label-col="{span: 24}" :wrapper-col="{span: 24}" label="Vyhľadávanie v položkách" class="mb-0">
                <a-input-search
      placeholder="Zadajte názov, značku, alebo kód položky"
     @search="(e) => fetchUser(e,data['settings']['contentType'])"
    />
            </a-form-item>


<a-spin v-if="fetching" slot="notFoundContent" size="small" />
<div class="finduser clickable-td" v-if="searchdata.length > 0" style="max-height:300px;overflow-y:scroll">
<div class="mb-3">Výsledky vyhľadávania:</div>
    <table class="w-100" >
        <template  v-for="user in searchdata">
                    <tr :key="user.id" class="selectable-row">
                    <td v-if="user.image" style="width:60px;margin-right:12px;text-align:center;"><span><img :src="user.image.styled" width="100%"></span></td>
                    <td v-else style="width:60px;text-align:center;">-</td>
                    <td style="width:200px;"><span>{{user.value}}</span></td>
                    <td style="width:150px;display:block;">{{user.url}}</td>
                    <td v-if="user.price" style="width:100px;display:block;text-align:right;">{{user.price}} €</td>
                    <td v-else style="width:100px;display:block;text-align:center;">-</td>
                    <td style="width:100px;text-align:right;display:block;"><a-button @click="addProductItem(user)">+ pridať</a-button></td>
                    </tr>
        </template>
    </table>
</div>
<div v-if="multidata.id" class="override-node">
  <h4>Prepis polí konkrétnej položky</h4>
  <template v-for="mdata,slug in elements">
    <div :key="'node' + slug + multidata.id">
    <div v-if="fieldTypes[data[mdata]] == 3" class="mb-2">
    <label class="form-control-label"><template v-if="fields[mdata].name">{{fields[mdata].name}}</template><template v-else>{{mdata}}</template>:</label>
    <image-upload :data="multidata[data[mdata]]" :label="mdata" :dat="slug"  @changed="(e) => onChildChange(e,data[mdata])"></image-upload>
</div>

<div v-if="fieldTypes[data[mdata]] == 1 || fieldTypes[data[mdata]] == 6" class="mb-2">
  <a-row :gutter="6">
    <a-col :span="12">
  <label class="form-control-label"><template v-if="fields[mdata].name">{{fields[mdata].name}}</template><template v-else>{{mdata}}</template>:</label>
    <a-input v-model="multidata[data[mdata]]"/>
  </a-col>
  <a-col :span="12" v-if="data[mdata] != 'url' && fieldTypes[data[mdata]] != 6">
    <label class="form-control-label"><template v-if="fields[mdata].name">{{fields[mdata].name}}</template><template v-else>{{mdata}}</template> suffix:</label>
    <a-input v-model="multidata[data[mdata]+'_suffix']"/>
  </a-col>
  <a-col  :span="12" v-if="data[mdata] == 'url'" style="text-align:right">
    <label class="form-control-label w-100"></label>
    <a v-if="multidata.url" :href="vars.site_url + '/' + multidata.language + '/' + multidata.url"  target="_blank" class="mt-4" >
                    <template>
                        <a-button type="secondary">Zobraziť stránku</a-button>
                    </template>
                </a>
                 <router-link :to="'/edit-content/' + multidata.id" > <a-button type="secondary">Uprav stránku</a-button></router-link>
  </a-col>
  </a-row>
</div>


    </div>
  </template>
  <a-row>
    <a-col :span="24" class="text-right">
      <a-button type="primary" @click="saveOverride">Ulož prepis</a-button>
    </a-col>
  </a-row>

</div>
</a-col>

</a-row>
      </a-modal>
      <a-modal :title="'Pridať položku: ' + assignTypeMulti.title" class="finduserModal"  :width="700" centered v-model="assignTypeModal" :footer="assignTypeMulti.multi == 1" v-if="assignTypeModal">
      <a-row :gutter="36">
        <a-col :span="24">
            <a-form-item :label-col="{span: 24}" :wrapper-col="{span: 24}"   class="m-0">
              <a-input-search :placeholder="'Vyhľadávanie v položkách typu: ' + assignTypeMulti.title" enter-button @search="(e) => fetchUser(e,contentTypeSelect,assignTypeMulti)" />
            </a-form-item>

<a-spin v-if="fetching" slot="notFoundContent" size="small" />
  <div class="finduser clickable-td" v-if="searchdata.length > 0" style="max-height:300px;overflow-y:auto" >
    <table class="w-100 slim table" >

    <tr class="header-row">
        <template v-for="admf in assignTypeMulti.adminfieldsTitle">
          <th :key="'hte-' + admf.title + admf.slug">{{admf.title}}</th>
        </template>
        <th></th>

    </tr>
    <template  v-for="user in searchdata">
    <tr :key="'user-' + user.id" class="selectable-row-noflex">
    <template v-for="field in contenttype.fields">
      <template v-if="field.id == assignTypeMulti.id">
        <template v-if="field.adminfields">
          <template v-for="admf in field.adminfields">
          <td :style="'text-align:center;'" :key="admf + 'ef' + field.id" v-if="user[admf]" >{{user[admf]}}</td><td v-else>-</td>
          </template>
        </template>
      </template>
    </template>
    <td style="text-align:right;"><template v-if="assignTypeMulti.multi == 1"><a-button @click="addProductItem(assignTypeMulti.slug,user)">+ pridať</a-button></template><template v-else>
     <a-button @click="getCTdetail(user,false)" class="mr-2">Detail</a-button>
     <a-button @click="addProductOneItem(assignTypeMulti.slug,user)"  type="primary">Vybrať</a-button>
        </template></td>
    </tr>
    </template>
    </table>
  </div>
</a-col>

</a-row>


        </a-modal>


<a-modal
  v-model="newDocumentModalVisible"
  title="Nový dokument"
  :okButtonProps="{ disabled: !newDocumentUploadedFile }"
  okText="Pridať"
  cancelText="Zrušiť"
  @ok="confirmNewDocument"
>
  <a-input v-model="newDocumentName" placeholder="Názov dokumentu" class="mb-2" />
  <a-textarea v-model="newDocumentDescription" placeholder="Popis (nepovinné)" rows="3" />

  <div v-if="newDocumentUploadedFile" class="mt-2">
    ✅ Nahraný súbor: <strong>{{ newDocumentUploadedFile.filename }}</strong>
  </div>

  <a-upload :customRequest="uploadNewDocumentFile" :showUploadList="false">
    <a-button class="mt-2"><span>Vložiť súbor dokumentu</span></a-button>
  </a-upload>
</a-modal>

        <a-modal title="Nastavenia obrázka v galérii" centered  v-model="ImagesetupVisible" v-if="ImagesetupVisible" @ok="setupImageOK">
        <a-form-item  label="Štýl obrázka" class="image-property">
            <a-select placeholder="štýl obrázka" class="w-100" v-model="imageToSet.style" :options="styles"/>
        </a-form-item>
            <a-form-item label="Názov obrázka" class="image-property">
                <a-input placeholder="Názov"  class=" "  v-model="imageToSet.title" />
            </a-form-item>
            <a-form-item   label="Alt tag obrázka" class="image-property">
                <a-input placeholder="Alt"  class=" "  v-model="imageToSet.alt" />
            </a-form-item>
        </a-modal>

        <a-modal :title="'Nastavenia poľa: ' + updateFieldModalData.contenttypes.groups[0].title" centered  v-model="updateFieldModal" v-if="updateFieldModal" @ok="updateFieldDo">
<div class="col-lg-12" :key="index" v-for="(field, index) in updateFieldModalData.contenttypes.fields">
 <div class="mb-3" v-if="field.type === '9'">

                                                <div v-if="field.slug === 'beecount'">
                                              <a-form-item >
                                                   <a-row class="w-100" gutter="12">
                                                    <a-col :span="4">
                                                    <a-form-item label="Počet">
                                                    <a-input-number class="w-100" v-model="updateFieldModalData.data[field.slug].count"/>
                                                    </a-form-item>
                                                    </a-col>
                                                    <a-col :span="18">
                                                     <a-form-item label="Hodnota platná od" >
                                                      <a-date-picker  v-model="updateFieldModalData.data[field.slug].validFrom" :locale="locale2"  /></a-form-item>
                                                    </a-col>
                                                    </a-row>
                                                    </a-form-item>
                                                </div>

                                            </div>
 </div>

 </a-modal>

   <a-modal title="Verzie nastavenia" centered  v-model="schedulemodal"  @cancel="slugSave = false" v-if="schedulemodal">
                            <template>

<template v-if="slugSave.nextvalues">
  <h4>Naplánované hodnoty</h4>

  <table class="w-100 table">
    <thead><tr><th style="width:270px;">Hodnota</th><th>Platná od</th><th></th></tr></thead>
    <tbody>
    <template v-for="next in slugSave.nextvalues">
<tr :key="next.id + 'nextv'" class="p-1"><td><template >{{ next.value }}</template>
</td><td>{{ formatDatedJD(next.datefrom) }}</td><td style="text-align:right"><a-button size="small" @click="removeScheduled(next.id)">Vymazať</a-button></td></tr>
    </template>
  </tbody>
  </table>
</template>


<template v-if="slugSave.historical">
   <h5>Predchádzajúce hodnoty</h5>


  <table class="w-100 table">

    <thead><tr><th style="width:220px;">Hodnota</th><th>Platná do</th></tr></thead>
    <tbody>
    <template v-for="next in slugSave.historical">
<tr :key="next.id + 'nextv'" class="p-1"><td><template v-if="slugSave.type != '50' && slugSave.type != '9'">{{ next.value }}</template>
<template v-else>
<template v-if="slugSave.type == '50'">
      <template v-for="(producttype,li) in JSON.parse(fieldData[slugSave.setup].value)">
        <a-row class="one-rower" :gutter="16" :key="producttype + 'a' + refreshkey">
          <a-col :span="14">
            <template v-for="op in options[fieldData.products.id]">
            <span style="margin-top:35px" :key="op.value" v-if="op.value == producttype"><div>{{op.label}}</div></span>
            </template>
          </a-col>
        </a-row>
      </template>
      </template>

      <template v-if="slugSave.type == '9'">
        {{formatDateS(JSON.parse(next.value).validFrom)}} - {{JSON.parse(next.value).count}}
      </template>

      <template v-if="next.value[producttype]">
        <a-col :span="4" >{{ next.value[producttype].unit }}</a-col>
        <a-col :span="4" > {{ next.value[producttype].tax }}</a-col>
      </template>

</template>
</td><td>{{ formatDatedJD(next.dateto) }}</td></tr>
    </template>
  </tbody>
  </table>
</template>



                                <template slot="footer"  style="padding-top:0;">
                                    <a-button  type="white" class="ml-auto" @click="schedulemodal = false;">Zatvoriť
                                    </a-button>
                                </template>
                            </template>
                        </a-modal>

                        <a-modal title="Naplánovať hodnotu" centered  v-model="fieldSetupModal"  @cancel="slugSave = false" v-if="fieldSetupModal">
                            <template>
                                <div class="a-modal">

                                  <template v-if="slugSave.type === '7'">
                                    <a-form-item :label="slugSave.title"  :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                      <a-checkbox class="mb-3" v-model="slugSave.value" />
                                    </a-form-item>
                                  </template>

                                 <template v-if="slugSave.type !== '7'">
                                 <a-form-item :label="slugSave.title"  :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                  <a-input v-model="slugSave.value"/>
                                 </a-form-item>
                                 </template>

                                </div>
                                <a-form-item label="Hodnota bude platná od"  :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                <a-date-picker :default-value="moment().add(1, 'day')" v-model="slugSave.datefrom" :locale="locale2"  />
                              </a-form-item>


                                <template slot="footer"  style="padding-top:0;">
                                    <a-button  type="white" class="ml-auto" @click="closeFieldPlanner">Zatvoriť
                                    </a-button>
                                    <a-button type="primary" @click="addScheduled"> Vytvoriť</a-button>
                                </template>
                            </template>
                        </a-modal>

  <a-modal :title="loadingModal ? 'Nahrávame položku...' : (exampleData.ctt + ': ' + (exampleData.data ? exampleData.data.title : ''))" cancelText="Zrušiť" :footer="!hideChoose" okText="Vybrať" centered  v-model="exampleModal" v-if="exampleModal" @ok="addProductOneItem(assignTypeMulti.slug,exampleData)">
    <a-spin v-if="loadingModal"></a-spin>
    <template v-else>
    <template v-for="field in exampleData.contenttypes.fields">
        <template v-if="field.type != '28' && field.type != '20' ">
           <a-row style="line-height:30px;" :key="'kf' + field.id + field.slug">
        <a-col :span="8">{{field.title}}</a-col>
        <a-col :span="16">
          <template v-if="field.type == '12'">{{exampleData.data[field.slug+'_data'].title}}</template>
          <template v-if="field.type == '21'">{{exampleData.data[field.slug].address}}</template>
          <template v-if="field.type == '4'"><div v-html="exampleData.data[field.slug]"></div></template>
          <template v-if="field.type == '8'">{{exampleData.data[field.slug+'_datax'][exampleData.data[field.slug]].title}}</template>
          <template v-if="field.type == '9' && exampleData.data[field.slug]">{{formatDateS(exampleData.data[field.slug].validFrom)}} - {{exampleData.data[field.slug].count}}</template>
          <template v-if="field.type == '19'"> <a-button type="default" class="mb-2" @click="downloadAllApprovedDocumentsDirect(exampleData.data[field.slug])">
          <i class="fas fa-file-archive mr-2"></i>Stiahni schválené dokumenty</a-button></template>
          <template v-if="field.type != '8' && field.type != '12' && field.type != '21' && field.type != '9' && field.type != '19' && field.type != '4'">
            <template v-if="field.type == '2'">{{exampleData.data[field.slug + '_datas'][0]}}</template>
            <template v-else>
              <template v-if="exampleData.data[field.slug]">
              {{exampleData.data[field.slug]}}</template>
              <span v-else><i class="fa fa-times"></i></span>
              </template>
              </template>

          </a-col>
        </a-row>    </template>
</template>
<template v-if="exampleData.data.gpsmapLink"><a-row style="line-height:30px;"><a-col :span="8">Mapa</a-col>
  <a-col :span="16">
    <div class="w-100"><a :href="exampleData.data.gpsmapLink" target="_blank"><a-button size="small">Zobraziť v Google Maps</a-button></a></div>
    <div class="w-100"><a :href="exampleData.data.gpsKataster" target="_blank"><a-button size="small">Zobraziť v Katastri</a-button></a></div>
    </a-col></a-row>

    </template>
    <hr>
    <a-row style="line-height:30px;"><a-col :span="8">Vytvorené</a-col><a-col :span="16">{{formatDateX(exampleData.created)}}</a-col></a-row>
    <a-row style="line-height:30px;"><a-col :span="8">Posledná zmena</a-col><a-col :span="16">{{formatDateX(exampleData.modified)}}</a-col></a-row>
   </template>

        </a-modal>

</CCardBody>
</CCard>
</CCol>
<CCol col="12" xl="2" class="sidebar-actions-col sidebar-sticky">
<CCard class="pl-0">
  <CCardBody>
    <a-card class="edit-card" style="margin:0; padding:15px;" :loading="saving">

                                <template  v-if="revisions"><a-button style="float:left; margin-top:-2px;"  class="btn btn-primary" @click="revisionsShow = true"><i class="fal fa-history" style="position:relative;top:-6px;"></i></a-button>
                                    <span class="revision-date" style="display:block;float:left;font-size:12px;line-height:14px">Posledná revízia:<br>{{formatDateP(revisions[0].created)}}</span>
                                   </template>
                                   <div class="w-100" >Typ obsahu:<span class="float-right"><router-link class="text-dark" :to="'/content/' + cttt">{{ct}}</router-link></span></div>
                                   <div v-if="created" class="w-100" >Vytvorené:<span class="float-right">{{formatDateX(created)}}</span></div>
                      <div v-if="modified && modified != created"  class="w-100" >Posledná zmena:<span class="float-right">{{formatDateX(modified)}}</span></div>


                                <div class="option-buttons">
                                  <a v-if="fieldData.url" :href="vars.site_url + '/' + fieldData.language + '/' + fieldData.url"  target="_blank" >
                    <template>
                        <a-button class="fs-12">Zobraziť stránku</a-button>
                    </template>
                </a>
                                    <a-button type="secondary" class="fs-12" @click="cloneNode">Klonovať stránku</a-button>
                                    <template v-if="permissions">
 <template v-if="permissions.includes('jsonImport')">
                                    <a-button type="secondary"  class="fs-12"   @click="exportNode">Export stránky</a-button>
                                    </template>
                                    </template>
                                    <router-link  v-if="fieldData['language'] === 'sk'" :to="'/translate/' + id"  :href="'/translate/' + id">
                                      <a-button type="secondary" class="fs-12">Preložiť stránku</a-button></router-link>

                                    <a-button v-if="vars.site_id" type="secondary" class="fs-12" :loading="reimporting" @click="reimportFromBSW">Resync</a-button>

                                    <a-popconfirm placement="topRight"
                                                  @confirm="confirm(id)"
                                                  @cancel="cancel"
                                                  okText="Áno"
                                                  cancelText="Nie">
                                        <template slot="title">
                                            <h5 color="danger" >Prajete si tento obsah vymazať?</h5>
                                            Položka bude trvalo odstránená z vašej stránky.
                                        </template>
                                        <a-button type="danger" class="fs-12">Zmazať stránku</a-button>
                                    </a-popconfirm>
                                    <a-button type="primary"  class="fs-12"  @click="handleSubmit">Uložiť stránku</a-button>
                            </div>

      </a-card>

  </CCardBody>
</CCard>
  </CCol>
</CRow>
    </div>
</template>
<script>
    import {getURL} from "../api";
    import {authHeader} from "../_helpers";
    import {dataService} from "../_services";
    import Vue from "vue"
    import FormItem from 'ant-design-vue'
    import ImageQ from "./content/Image";
    import Upload from "./content/Upload";

    import GpsMapPicker from './GpsMapPicker.vue'

    import {IMG_URL} from "../api";

    import AUpload from "ant-design-vue/es/upload";
    import AFormItem from "ant-design-vue/es/form/FormItem";
    import AInput from "ant-design-vue/es/input";
    import ADatePicker from "ant-design-vue/es/date-picker";
    import {Cropper} from 'vue-advanced-cropper'
    import BetaEditor from "./content/BetaEditor";
    import Multi from "./content/multi";
    import moment from 'moment'
    import 'moment/locale/sk';
    import Field from './Field';
    import JSZip from 'jszip';
    import Fields from './Fields';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import PdfViewer from './PdfViewer.vue';
    import ImageViewer from './ImageViewer.vue';
 import { CChartLine } from '@coreui/vue-chartjs'

    // Import translations for the German language.
    import '@ckeditor/ckeditor5-build-classic/build/translations/sk';

    import draggable from "vuedraggable";
    // eslint-disable-next-line no-unused-vars
    import UploadAdapter from './UploadAdapter';

var locale2 = {
        "lang": {
            "placeholder": "Vybrať dátum",
            "rangePlaceholder": ["Začiatok", "Koniec"],
            "today": "Dnes",
            "now": "Teraz",
            "backToToday": "Späť na dnes",
            "ok": "Ok",
            "clear": "Vymazať",
            "month": "Mesiac",
            "year": "Rok",
            "timeSelect": "Vybrať čas",
            "dateSelect": "Vybrať dátum",
            "monthSelect": "Vybrať mesiac",
            "yearSelect": "Vybrať rok",
            "decadeSelect": "Vybrať dekádu",
            "yearFormat": "YYYY",
            "dateFormat": "M/D/YYYY",
            "dayFormat": "D",
            "dateTimeFormat": "M/D/YYYY HH:mm:ss",
            "monthFormat": "MMMM",
            "monthBeforeYear": true,
            "previousMonth": "Predchádzajúci mesiac (PageUp)",
            "nextMonth": "Nasledujúci mesiac (PageDown)",
            "previousYear": "Minulý rok (Control + left)",
            "nextYear": "Nasledujúci rok (Control + right)",
            "previousDecade": "Minulá dekáda",
            "nextDecade": "Nasledujúca dekáda",
            "previousCentury": "Minulé storočie",
            "nextCentury": "Nasledujúce storočie"
        },
        "timePickerLocale": {
            "placeholder": "Vybrať čas"
        },
        "dateFormat": "DD.MM.YYYY",
        "dateTimeFormat": "DD.MM.YYYY HH:mm:ss",
        "weekFormat": "YYYY-wo",
        "monthFormat": "MMMM YYYY"
    }
    var locale = {
        "lang": {
            "placeholder": "Vybrať dátum",
            "rangePlaceholder": ["Začiatok", "Koniec"],
            "today": "Dnes",
            "now": "Teraz",
            "backToToday": "Späť na dnes",
            "ok": "Ok",
            "clear": "Vymazať",
            "month": "Mesiac",
            "year": "Rok",
            "timeSelect": "Vybrať čas",
            "dateSelect": "Vybrať dátum",
            "monthSelect": "Vybrať mesiac",
            "yearSelect": "Vybrať rok",
            "decadeSelect": "Vybrať dekádu",
            "yearFormat": "YYYY",
            "dateFormat": "M/D/YYYY",
            "dayFormat": "D",
            "dateTimeFormat": "M/D/YYYY HH:mm:ss",
            "monthFormat": "MMMM",
            "monthBeforeYear": true,
            "previousMonth": "Predchádzajúci mesiac (PageUp)",
            "nextMonth": "Nasledujúci mesiac (PageDown)",
            "previousYear": "Minulý rok (Control + left)",
            "nextYear": "Nasledujúci rok (Control + right)",
            "previousDecade": "Minulá dekáda",
            "nextDecade": "Nasledujúca dekáda",
            "previousCentury": "Minulé storočie",
            "nextCentury": "Nasledujúce storočie"
        },
        "timePickerLocale": {
            "placeholder": "Vybrať čas"
        },
        "dateFormat": "DD.MM.YYYY",
        "dateTimeFormat": "DD.MM.YYYY HH:mm:ss",
        "weekFormat": "YYYY-wo",
        "monthFormat": "YYYY-MM"
    }

    Vue.use(FormItem);
    Vue.use(Cropper);


    function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {type: mime});
    }

    export default {
        name: 'editcontent',
        components: {Multi,
            draggable,
            AUpload,
            PdfViewer,
            ImageViewer,
            CChartLine,
            AInput,
            GpsMapPicker,
            "betaeditor": BetaEditor,
            ADatePicker,
            "field":Field,
            "fields":Fields,AFormItem,'image-upload' : ImageQ,
            Upload},
        props: ['id','mid'],
        data() {
            return {
               windowWidth: window.innerWidth,
               historic: {},               // { slug: [ {id, value, valid_from}, ... ] }
    historicModalVisible: false,
    historicFieldSlug: null,
    currentHistoric: {
      id: null,
      date: null,
      value: null
    },
                url: getURL(),
                fieldData: {},
                exampleModal:false,
                exampleData: {},
                 slugSave: false,
                locale2,
                nodeStats: [],
                priceStats: null,
                activeContentTab: 0,
                priceStatsLoading: false,
                priceStatsDays: 30,
                rearangablefiles: 0,
                colorsto: JSON.parse(localStorage.colors),
                permissions:JSON.parse(localStorage.user).data.permissions,
                formData: null,
                showLoadingMore:true,
                fileList: [],
                  newDocumentModalVisible: false,
    newDocumentName: '',
    newDocumentDescription: '',
    newDocumentUploadedFile: null,
    currentUploadSlug: '',
                userID: JSON.parse(localStorage.user).data.id,
                locale,
                fieldtoselect:false,
                IMG_URL,
                rows: [],
                gpxLoader:false,
                 pendingConvertedPdf: null,
                 loadingModal:false,
                assignTypeModal:false,
                commentsByFile: {},
                expandedVersions: {},
                updateFieldModal: false,
                updateFieldModalData: {},
                selectedNodes:[],
                 pdfComments: [],
                 comments: [],
    pdfMode: true,
                pdfPreviewActive: false,
pdfPreviewData: {
  uri: null,
  fid: null,
  title: '',
  slug: '',
  docIndex: null
},
                assignTypeMulti:false,
                assignTypeValue:[],
                mapID: 0,
                dataSource:{},
                contentTypeSelect:false,
                revision:false,
                newTerm:false,
                multidata:[],
                searchdata:[],
                newTermToAdd:"",
                newTermFid:"",
                showImportModalImages:false,
                languages:[],
                translations:[],
                imagesToAdd:{},
                revisions:false,
                projections:[[]],
                fetching: false,
                 drag: false,
                hasOwntitle:false,
                autourl:true,
                addContentShow: false,
                generating: false,
                refreshAll:0,
                created:false,
                next:false,
                productSlug:"",
                taxonomies: {},
                hideChoose:false,
                productSearch:false,
                fieldaddtitle:"",
                prev:false,
                modified:false,
                lat:0,
                lng:0,
                revisionsShow:false,
                imageToSet:{},
                hasBuilder:false,
                hasMultiDocuments:false,
                hasProductOptions:false,
                saving:false,
                reimporting:false,
                refreshassignlist:0,
                context:[],
                crawlUrl:"",
                showoptions:[],
                contexts: {},
                ImagesetupVisible:false,
                styles:[],
                temp:{},
                componentKey:0,
                forceRefresh:0,
                translatedata:[],
                labelCol: { span: 4 },
                defaultLanguage:'sk',
                wrapperCol: { span: 20 },
                labelCol2: { span: 10 },
                wrapperCol2: { span: 14 },
                labelCol3: { span: 24 },
                wrapperCol3: { span: 24 },
                fieldSetupModal: false,
                schedulemodal:false,
                updateNID: false,
                updateFieldSlug: false,
                reloadimages:{},
                productOptionsCategories: [],
                productOptions: [],
                productRelations: null,
                productRelationSearchType: null,
                pdfResolvedUrl: '',
                showImages:false,
                crawledImages:[],
                reloadgalleries:0,
                history:[],
                restoringHistoryId: null,
                historyDiffVisible: false,
                historyDiffLoading: false,
                historyDiffFields: [],
                historyDiffMeta: {},
                historyDiffBackup: null,
                historyDiffViewMode: 'text',
                historyDiffPreviewCurrent: null,
                historyDiffPreviewBackup: null,
                historyDiffHasBuilder: false,
                editor: ClassicEditor,
                editorConfig: {
                    heading: {
                        options: [
                            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                            { model: 'heading3', view: 'h3', title: 'Písané', class: 'ck-heading_heading3' },
                        ]
                    },
                    toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'insertTable', '|', 'subscript','imageUpload', 'mediaEmbed', '|', 'undo', 'redo', '|', 'HtmlEmbed', ],
                    table: {
                        toolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
                    },
                    extraPlugins: [this.uploader],
                    language: 'sk',
                },
                vars:  {},
                rearanged: false,
                fieldSlug:'',
                head: authHeader(),
                types: [
                    {"value": '1', "label": 'Text'},
                    {"value": '2', "label": 'Výberovník'},
                    {"value": '3', "label": 'Obrázok'},
                    {"value": '4', "label": 'Dlhý text'},
                    {"value": '5', "label": 'Celé číslo'},
                    {"value": '6', "label": 'Desatiné číslo'},
                    {"value": '7', "label": 'Logická hodnota Áno/Nie'},
                ],
                historyState:
                    {
                    "create": 'Vytvorené',
                    "update": 'Aktualizácia',
                    "updateDocuments": "Aktualizácia dokumentov"
                  },
                ct: null,
                ctt: null,
                cttt: null,
                formItemLayout: {
                    labelCol: {
                        xs: {span: 24},
                        sm: {span: 4},
                    },
                    wrapperCol: {
                        xs: {span: 24},
                        sm: {span: 20},
                    },
                },
                formItemLayoutWithOutLabel: {
                    wrapperCol: {
                        xs: {span: 24, offset: 0},
                        sm: {span: 20, offset: 4},
                    },
                },
                contenttypeId: {
                    uid: this.id
                },
                options: [],
                contenttype: {
                    title: '',
                    type: '',
                },
            }
        },
        methods: {
            handleResize() {
              this.windowWidth = window.innerWidth;
            },
 onMapChange(value, slug) {
  if (!value || !value.position) return

  const lat = parseFloat(value.position.lat)
  const lng = parseFloat(value.position.lng)
  if (isNaN(lat) || isNaN(lng)) return

  // UI formát – lat+lng+address
  this.$set(this.fieldData, slug, {
    lat,
    lng,
    address: value.address || null,
  })

  // spätná kompatibilita – coords (string "lat, lng")
  if (
    Array.isArray(this.fieldData.coords) &&
    this.fieldData.coords[0] &&
    this.fieldData.coords[0][0] !== undefined
  ) {
    this.fieldData.coords[0][0] = `${lat}, ${lng}`
  }

  // spätná kompatibilita – gpspoint
  if (!this.fieldData.gpspoint) {
    this.$set(this.fieldData, 'gpspoint', { lat, lng })
  } else {
    this.fieldData.gpspoint.lat = lat
    this.fieldData.gpspoint.lng = lng
  }

  if (!this.hasOwntitle && !this.fieldData.title && value.address) {
    this.fieldData.title = value.address
  }

  this.componentKey += 1
},


          async openHistoricModal(slug, defaultValue = null) {
  this.historicFieldSlug = slug;

  if (!this.historic) {
    this.historic = {};
  }

  try {
    // Načítaj históriu len pre daný slug
    const res = await dataService.axiosPost('getfieldhistoric/' + this.id, { slug: slug });
    const data = res && res.data && res.data.data ? res.data.data : {};
    const rawRows = data.rows || [];

    const rows = this.normalizeHistoricRows(rawRows, slug, this.id);

    // uložíme históriu pre daný slug (reaktívne)
    this.$set(this.historic, slug, rows);
  } catch (e) {
    console.error(e);
    this.$message.error('Chyba pri načítaní histórie.');
  }

  // predvyplnenie dialógu – TOTO je len v modale, nie v hlavnom poli
  this.currentHistoric = {
    id: null,
    date: this.moment(), // dnešný dátum
    value:
      defaultValue !== null && defaultValue !== undefined
        ? Number(defaultValue)
        : null
  };

  this.historicModalVisible = true;
},


editHistoric(slug, row) {
  this.historicFieldSlug = slug;
  this.currentHistoric = {
    id: row.id,
    date: this.moment(row.valid_from || row.date),
    value: Number(row.value)
  };
  this.historicModalVisible = true;
},
async saveHistoric() {
  const slug = this.historicFieldSlug;

  if (!slug || !this.currentHistoric.date || this.currentHistoric.value === null) {
    this.$message.error('Vyplňte dátum aj hodnotu.');
    return;
  }

  // nedovoľ uložiť dátum v budúcnosti (pre istotu aj keby sa disabledDate obišiel)
  if (this.currentHistoric.date.isAfter(this.moment(), 'day')) {
    this.$message.error('Dátum nemôže byť v budúcnosti.');
    return;
  }

  const payload = {
    id: this.currentHistoric.id,
    nid: this.id,
    slug: slug,
    value: this.currentHistoric.value,
    date: this.currentHistoric.date.format('YYYY-MM-DD'),
  };

  try {
    const res = await dataService.axiosPost('fieldhistoric', payload);
    const body = res && res.data ? res.data.data : {};

    if (!body || body.success === false) {
      this.$message.error('Chyba pri ukladaní historickej hodnoty.');
      return;
    }

    await this.reloadHistoric(slug);

    this.historicModalVisible = false;
    this.$message.success('Záznam uložený.');
  } catch (e) {
    console.error(e);
    this.$message.error('Chyba pri ukladaní historickej hodnoty.');
  }
},

async deleteHistoric(slug, id) {
  try {
    await dataService.axiosDelete('fieldhistoric', id);
    const list = (this.historic[slug] || []).filter(row => row.id !== id);
    this.$set(this.historic, slug, list);
    this.$message.success('Záznam zmazaný.');
  } catch (e) {
    console.error(e);
    this.$message.error('Chyba pri mazaní záznamu.');
  }
},
disableFutureDates(current) {
  // zakáže všetko striktne po dnešnom dni
  return current && current > this.moment().endOf('day');
},

normalizeHistoricRows(rawRows, slug, nid) {
  if (!rawRows) {
    return [];
  }

  var self = this;

  var rows = rawRows.map(function (r) {
    // id
    var id = r.id ? Number(r.id) : null;

    // nid / entity_id
    var nidVal = null;
    if (typeof r.nid !== 'undefined' && r.nid !== null) {
      nidVal = Number(r.nid);
    } else if (typeof r.entity_id !== 'undefined' && r.entity_id !== null) {
      nidVal = Number(r.entity_id);
    } else if (nid !== null && nid !== undefined) {
      nidVal = Number(nid);
    }

    // slug / field_name
    var slugVal = null;
    if (typeof r.slug !== 'undefined' && r.slug !== null) {
      slugVal = r.slug;
    } else if (typeof r.field_name !== 'undefined' && r.field_name !== null) {
      slugVal = r.field_name;
    } else {
      slugVal = slug;
    }

    // value (preferuj r.value, inak r.new_value)
    var value = null;
    if (typeof r.value !== 'undefined' && r.value !== null) {
      value = r.value;
    } else if (typeof r.new_value !== 'undefined' && r.new_value !== null) {
      value = r.new_value;
    }

    // prevedie na číslo, ak to ide
    if (value !== null && value !== undefined && !isNaN(value)) {
      value = Number(value);
    }

    // dátum – z changed_at alebo date/valid_from
    var changedAt = null;
    if (typeof r.changed_at !== 'undefined' && r.changed_at !== null) {
      changedAt = r.changed_at;
    }

    var dateOnly = null;

    if (typeof r.date !== 'undefined' && r.date !== null) {
      dateOnly = r.date;
    } else if (typeof r.valid_from !== 'undefined' && r.valid_from !== null) {
      dateOnly = r.valid_from;
    } else if (changedAt) {
      // urob len YYYY-MM-DD
      dateOnly = changedAt.length >= 10 ? changedAt.substr(0, 10) : changedAt;
    }

    var userId = null;
    if (typeof r.user_id !== 'undefined') {
      userId = r.user_id;
    } else if (typeof r.changed_by !== 'undefined') {
      userId = r.changed_by;
    }

    return {
      id: id,
      nid: nidVal,
      slug: slugVal,
      value: value,
      old_value: typeof r.old_value !== 'undefined' ? r.old_value : null,
      date: dateOnly,
      valid_from: typeof r.valid_from !== 'undefined' && r.valid_from !== null
        ? r.valid_from
        : dateOnly,
      changed_at: changedAt,
      user_id: userId
    };
  });

  // zoradenie ako si mal doteraz (najnovšie hore)
  rows.sort(function (a, b) {
    var da = a.valid_from || a.date || '';
    var db = b.valid_from || b.date || '';
    if (da < db) {
      return 1;
    }
    if (da > db) {
      return -1;
    }
    return 0;
  });

  return rows;
},

            onReady(editor) {
      const viewDoc = editor.editing.view.document;

      // najvyššia priorita, aby sme prebrali udalosť skôr než Enter-plugin
      viewDoc.on(
        'enter',
        (evt, data) => {
          evt.stop();               // zastaví default spracovanie (nový <p>)
          editor.execute('shiftEnter'); // vloží <br> ako pri Shift+Enter  :contentReference[oaicite:3]{index=3}
          data.preventDefault();
        },
        { priority: 'highest' }
      );
    },
    downloadFile(uri) {
      fetch(uri)
        .then(res => res.blob())
        .then(blob => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', uri.split('/').pop());
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    downloadAllApprovedDocumentsDirect(data) {
  const zip = new JSZip();
 console.log(data);
const files = Object.values(data || {})
    .map(doc => doc.versions?.[doc.versions.length - 1])
    .filter(ver => ver && ver.status === 'approved');

  const filePromises = files.map(ver =>
    fetch(ver.uri)
      .then(res => res.blob())
      .then(blob => zip.file(ver.filename, blob))
  );

  Promise.all(filePromises).then(() => {
    zip.generateAsync({ type: 'blob' }).then(content => {
      const url = URL.createObjectURL(content);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'approved_documents.zip';
      a.click();
      URL.revokeObjectURL(url);
    });
  });
},
downloadAllApprovedDocuments(slug) {
  const zip = new JSZip();

const files = Object.values(this.fieldData[slug] || {})
    .map(doc => doc.versions?.[doc.versions.length - 1])
    .filter(ver => ver && ver.status === 'approved');

  const filePromises = files.map(ver =>
    fetch(ver.uri)
      .then(res => res.blob())
      .then(blob => zip.file(ver.filename, blob))
  );

  Promise.all(filePromises).then(() => {
    zip.generateAsync({ type: 'blob' }).then(content => {
      const url = URL.createObjectURL(content);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'approved_documents.zip';
      a.click();
      URL.revokeObjectURL(url);
    });
  });
},
    toggleVersions(slug, docIndex) {
    const key = slug + '_' + docIndex;
    this.$set(this.expandedVersions, key, !this.expandedVersions[key]);
  },

          openNewDocumentModal(slug) {
  this.newDocumentModalVisible = true;
  this.currentUploadSlug = slug;
},

uploadVersion(slug, docIndex, info) {
  const formData = new FormData();
  formData.append('upload', info.file);

  this.axios.post(this.url.API_URL + '/upload/content', formData, {
    headers: authHeader(true)
  }).then(res => {
    const uploaded = res.data[0];

    this.fieldData[slug][docIndex].versions.push({
      fid: uploaded.fid,
      uri: uploaded.uri,
      filename: info.file.name,
      comments: [],
      uploaded_at: Date.now(),
      status: 'new',
      uploader: this.userID
    });

this.handleAutoSave(slug);
  });
},

removeVersion(slug, docIndex, versionIndex) {
  const versions = this.fieldData[slug][docIndex].versions;

  // Ak ostane len jedna verzia po zmazaní → zmaž celý dokument
  //if (versions.length === 1) {
  //  this.fieldData[slug].splice(docIndex, 1);
  //  return;
 // }

  versions.splice(versionIndex, 1);

  // Zatvor rozbalenie, ak ostane len jedna verzia
  if (versions.length === 1) {
    const key = slug + '_' + docIndex;
    this.$set(this.expandedVersions, key, false);

  }
this.handleAutoSave(slug);
},
    uploadDocument(info, slug) {
    const formData = new FormData();
    formData.append('upload', info.file);

    this.axios.post(this.url.API_URL + '/upload/content', formData, {
      headers: authHeader(true)
    }).then(res => {
      const uploaded = res.data[0];

      if (!Array.isArray(this.fieldData[slug])) {
        this.$set(this.fieldData, slug, []);
      }

      this.fieldData[slug].push({
  name: info.file.name,
  uri: uploaded.uri,
  fid: uploaded.fid,
  uploaded_at: Date.now(),
  status: 'new',
  uploader: this.userId
});


this.handleAutoSave(slug);
    });

    return false;
},


previewFile(fid, slug, docIndex, title = '', uri) {
  const extension = uri.split('.').pop().toLowerCase();

this.pdfPreviewData = { uri, fid, slug, docIndex, title };


  // Načítať existujúce komentáre z fieldData, ak sú
const doc = this.fieldData?.[slug]?.[docIndex];
if (doc && Array.isArray(doc.versions)) {
  const version = doc.versions.find(ver => ver.fid === fid);
  this.comments = version?.comments ? JSON.parse(JSON.stringify(version.comments)) : [];
}


if (extension === 'pdf' || extension === 'docx' || extension === 'doc') {
  this.pdfMode = true;
  }
  else
  {
    this.pdfMode = false;
  }
this.pdfPreviewActive = true;

},

handleCommentsUpdate(newComments) {
  const { slug, docIndex, fid } = this.pdfPreviewData;
  const doc = this.fieldData?.[slug]?.[docIndex];
  const version = doc?.versions?.find(ver => ver.fid === fid);

  if (version) {
    this.$set(version, 'comments', JSON.parse(JSON.stringify(newComments)));

this.handleAutoSave(slug);
    console.log("ULOŽENÉ:", version.comments);
  } else {
    console.warn("NEBOLA NÁJDENÁ VERZIA PODĽA FID");
  }
},



uploadNewDocumentFile(info) {
  const formData = new FormData();
  formData.append('upload', info.file);

  this.axios.post(this.url.API_URL + '/upload/content', formData, {
    headers: authHeader(true)
  }).then(res => {
    const uploaded = res.data[0];
    this.newDocumentUploadedFile = {
      fid: uploaded.fid,
      uri: uploaded.uri,
      filename: info.file.name,
      uploaded_at: Date.now(),
      status: 'new',
      uploader: this.userID
    };

  });
},
moment,
confirmNewDocument() {
  if (!this.newDocumentUploadedFile) return;

  const slug = this.currentUploadSlug;
  let current = this.fieldData[slug];

  // 🛡️ Konvertuj objekt s číselnými kľúčmi na pole
  if (!Array.isArray(current)) {
    const values = Object.values(current || {});
    current = values.filter(v => typeof v === 'object' && v.versions);
  }

  current.push({
    name: this.newDocumentName,
    description: this.newDocumentDescription,
    versions: [this.newDocumentUploadedFile]
  });

  this.$set(this.fieldData, slug, current);

  // Reset modalu
  this.newDocumentModalVisible = false;
  this.newDocumentName = '';
  this.newDocumentDescription = '';
  this.newDocumentUploadedFile = null;

this.handleAutoSave(slug);
},
sanitizeDocumentField(slug) {
  const current = this.fieldData[slug];

  if (!Array.isArray(current)) {
    const cleaned = Object.keys(current)
      .filter(k => !isNaN(k)) // len číselné indexy
      .map(k => current[k])
      .filter(v => typeof v === 'object' && v.versions);

    this.$set(this.fieldData, slug, cleaned);
  }
},
removeDocument(slug, index) {
  let current = this.fieldData[slug];

  if (!Array.isArray(current)) {
    current = Object.values(current).filter(v => typeof v === 'object');
  }

  current.splice(index, 1);
  this.$set(this.fieldData, slug, current);

this.handleAutoSave(slug);
},
          fetchUser(value,ct,field = false) {

if(value.length > 0)
{
this.lastFetchId += 1;
this.searchdata = [];
this.fetching = true;
this.fetching = false;
var ctt = false;
if(field)
{
  ct = field.slug;
}

dataService.axiosPost('findproducts', {searchterm: value,ct:ct,ctt:ctt,field_id:field}).then(results => {
this.searchdata = results.data.data;
});
}
},
  addScheduled()
            {
              dataService.axiosPost('addscheduledfield', this.slugSave).then(() => {
                this.fieldSetupModal = false;
                this.fetch();
              });
            },
        drop(info)
        {
        console.log(info);
        },
            IsJsonString(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
            },
            checkMove: function(evt) {

if(evt.to.dataset.type)
{
if(evt.to.dataset.type == 3)
{
if(evt.to.children.length > 0)
return false;
}
}
                         },
            addSelect() {

            },
            confirm(e) {
                 dataService.axiosDelete('content', e).then(() => {
                         this.$router.push('/content/' + this.cttt)

                });
            },
            removeItemFrom(slug,ind)
            {
              this.fieldData[slug].splice(ind, 1).filter(val => val);
              this.refreshassignlist = this.refreshassignlist  + 1;
            },

    translateAI(lang,string,slug,translatable)
            {
              var response = "";
              dataService.axiosPost("translateai", {lang:lang,string:string}).then(results => {
                  response = results.data[0];

if(translatable == true)
                  this.fieldData[slug + ":" + lang] = response;
                else
                this.fieldData[slug] = response;
                  });


            },
    addProductItem(slug,theItem)
    {

this.fieldData[slug].push({value: theItem.entity_id, 'label': theItem.value});

this.refreshassignlist = this.refreshassignlist  + 1;
    },
    addProductOneItem(slug,theItem)
    {
      this.assignTypeModal = false;
      this.exampleModal = false;
      this.fieldData[slug]  = theItem.entity_id;
      this.fieldData[slug + '_data']  = theItem.value;
    },
            addTerm(field)
            {
                this.newTermFid = field;
                this.newTerm = true;
            },
            addNewTerm()
            {
                dataService.axiosPost('addfieldtaxonomy/' + this.newTermFid.id, { 'title' : this.newTermToAdd}).then(results => {
                this.options[this.newTermFid.id].push({value:results.data[0],label: this.newTermToAdd});
                this.fieldData[this.newTermFid.slug] = results.data[0];
                this.newTerm = false;
                });
            },
            settheavalue(e) {
  const fieldId = this.addContentShow;

  if (!fieldId) {
    this.addContentShow = false;
    return;
  }

  // nájdeme definíciu poľa podľa ID
  const field = this.contenttype.fields.find(f => f.id == fieldId);

  if (!field) {
    this.addContentShow = false;
    return;
  }

  // typ 8 + multi (select s možnosťou pridať novú položku)
  if (field.type === '8' && field.multi === '1') {
    if (!this.options[fieldId]) {
      this.$set(this.options, fieldId, []);
    }
    this.options[fieldId].push(e);

    if (!this.fieldData.hasOwnProperty(field.slug)) {
      this.$set(this.fieldData, field.slug, []);
    }
    this.fieldData[field.slug].push(e.value);
  }

  // typ 28 – napr. „stanovištia“ (tabuľka)
  else if (field.type === '28') {
    // voliteľný placeholder – aby sa niečo zobrazilo hneď
    if (!Array.isArray(this.fieldData[field.slug])) {
      this.$set(this.fieldData, field.slug, []);
    }

    const newRow = { id: e.value };
    const existingRows = this.fieldData[field.slug];

    if (existingRows.length > 0) {
      const firstRow = existingRows[0];
      Object.keys(firstRow).forEach(key => {
        if (key !== 'id' && !newRow.hasOwnProperty(key)) {
          newRow[key] = null;
        }
      });
    }

    this.fieldData[field.slug].push(newRow);
  }

  // zavri modal
  this.addContentShow = false;

  // teraz nechaj backend znovu dopočítať DANÉ pole
  // (vrátane _datax, vypočítaných stĺpcov a pod.)
  if (!isNaN(this.id)) {
    dataService
      .axiosPost('content/' + this.id, { selectedFields: [field.slug] })
      .then(res => {
        if (res && res.data && res.data.data) {

          console.log(res);
          this.replaceUpdatedFields(res.data.data.data);
        }
      });
  }
},

          addContent(fieldID,title) {
            this.fieldaddtitle = title;
            this.fieldtoselect = this.contexts[fieldID];
            this.addContentShow = fieldID;
            },
            cancel() {
            },
            forceRerender() {
                this.componentKey += 1;
            },
            slugify(string) {
                const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
                const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
                const p = new RegExp(a.split('').join('|'), 'g')

                return string.toString().toLowerCase()
                    .replace(/\s+/g, '-') // Replace spaces with -
                    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                    .replace(/&/g, '-and-') // Replace & with 'and'
                    // eslint-disable-next-line no-useless-escape
                    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                    // eslint-disable-next-line no-useless-escape
                    .replace(/\-\-+/g, '-') // Replace multiple - with single -
                    .replace(/^-+/, '') // Trim - from start of text
                    .replace(/-+$/, '') // Trim - from end of text
            },
            setUrl()
            {
                this.fieldData['url'] = this.slugify(this.fieldData['title']);
                this.forceRerender();
            },
            uploader(editor)
            {
                editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                    return new UploadAdapter( loader );
                };
            },
            updateImage(rowIndex, imageData) {
      // Update the image data for the corresponding row
      this.fieldData.rows[rowIndex].image = imageData;
    },
            justOneImage(slug)
            {
            this.imagesToAdd[slug] = this.imagesToAdd[slug].splice(1);

            console.log(this.imagesToAdd[slug]);
            },
            sendImage(formData,slug)
            {

                const pa = this;
                this.axios.post(this.url.API_URL + '/upload/content',
                    formData,
                    {
                        headers: authHeader(true)
                    }
                ).then(function (data) {
                    pa.datatosave = data.data[0];

                    let items = [];
// eslint-disable-next-line no-unused-vars
let maxvalue  = 0;

                    var u = {}; u.image = data.data[0];

                    if(pa.IsJsonString(pa.fieldData[slug]) && pa.fieldData[slug] !== null)
                    {
                        items = JSON.parse(pa.fieldData[slug]);
                         items.push(u);

                    }
                    else
                    {
                        items.push(u);
                    }

                    pa.fieldData[slug] = JSON.stringify(items);

                });

            },
            cloneNode()
            {
                dataService.axiosPost('translate/' + this.id, { 'lang' : this.fieldData.language}).then(results => {
                    if(results.data)
                    {this.$router.push('/edit-content/' + results.data[0])}
                });
            },
            reimportFromBSW() {
                this.reimporting = true;
                dataService.axiosFetch('reimportproduct/' + this.id).then(results => {
                    if (results && results.success) {
                        this.$message.success('Produkt bol úspešne resynchronizovaný');
                        window.location.reload();
                    } else {
                        this.$message.error('Pri resynchronizácii nastala chyba');
                    }
                }).catch(() => {
                    this.$message.error('Pri resynchronizácii nastala chyba');
                }).finally(() => { this.reimporting = false; });
            },
            assignType(f,multi)
            {
              this.assignTypeModal = true;
              this.contentTypeSelect = f;
              this.assignTypeMulti = multi;
              this.assignTypeValue = false;

            },
            closeFieldPlanner()
            {
this.fieldSetupModal = false;
this.newExtra = {};
            },
            exportNode()
            {
        const blob = new Blob([JSON.stringify(this.fieldData)], { type: 'application/json' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'export-' + this.id;
        link.click()
        URL.revokeObjectURL(link.href)
         },
            hasAlpha (context, canvas) {
                var data = context.getImageData(0, 0, canvas.width, canvas.height).data,
                    hasAlphaPixels = false;
                for (var i = 3, n = data.length; i < n; i+=4) {
                    if (data[i] < 255) {
                        hasAlphaPixels = true;
                        break;
                    }
                }
                return hasAlphaPixels;
            },
            addRow() {


              this.fieldData.rows.push({
        selectedOptions: {}, // This will hold the selected option for each category
        image: null // This will hold the image for the row
      });

    },
    removeRow(index) {
      this.fieldData.rows.splice(index, 1); // Remove the row at the given index
    },
    generateCombinations(categories, options) {
  // Extract category IDs
  const categoryIds = Object.keys(categories);

  // Map category IDs to available product options
  const categoryOptions = categoryIds.map(categoryId => {
    return options
      .filter(option => option.category === categoryId)
      .map(option => ({
        category: categoryId, // Use category ID as key
        id: option.produktId2.id,
        title: option.produktId2.title,
        price: parseFloat(option.produktId2.price) || 0
      }));
  });

  // Generate the Cartesian product of category options
  return categoryOptions.reduce((acc, curr) => {
    const result = [];
    acc.forEach(existingCombination => {
      curr.forEach(option => {
        result.push([...existingCombination, option]);
      });
    });
    return result;
  }, [[]]);
},
fillAllCombinations() {
    if (!this.productOptionsCategories || !this.productOptions) {
      console.error("Missing productOptionsCategories or productOptions.");
      return;
    }

    // Generate all possible combinations
    const combinations = this.generateCombinations(this.productOptionsCategories, this.productOptions);

    // Convert the combinations into `selectedOptions` format
    this.fieldData.rows = combinations.map(combination => {
      const selectedOptions = {};
      let totalPrice = 0;

      combination.forEach(option => {
        selectedOptions[option.category] = option.id; // Assign category ID to selected option
        totalPrice += option.price; // Sum up the prices
      });

      return {
        selectedOptions, // Uses category IDs, not 0,1,2...
        totalPrice, // Sum of all selected prices
        image: null // Placeholder for image upload
      };
    });

    console.log("Generated rows:", this.fieldData.rows);
  },
            fetchProductRelations() {
              dataService.axiosFetch('productrelations/' + this.id).then(results => {
                if (results) {
                  this.productRelations = results;
                  this.hasProductOptions = true;
                } else {
                  this.productRelations = { parent: null, variants: [], configurable: [], accessories: [] };
                }
              }).catch(() => {
                this.productRelations = { parent: null, variants: [], configurable: [], accessories: [] };
              });
            },
            openProductRelationSearch(type) {
              this.productRelationSearchType = type;
              this.productSlug = 'productRelation_' + type;
              this.productSearch = true;
            },
            addProductRelation(type, product) {
              if (!this.productRelations) return;
              if (!this.productRelations[type]) this.$set(this.productRelations, type, []);
              const exists = this.productRelations[type].find(p => p.id === product.id || p.id === product.entity_id);
              if (exists) { this.$message.warning('Produkt je už priradený'); return; }
              this.productRelations[type].push({
                id: product.entity_id || product.id,
                title: product.value || product.title,
                image: product.image ? product.image.styled : null,
                price: product.price || null,
                attribute: product.atribute_data || null,
                description: product.description || null
              });
              this.saveProductRelations();
            },
            removeProductRelation(type, index) {
              this.productRelations[type].splice(index, 1);
              this.saveProductRelations();
            },
            saveProductRelations() {
              dataService.axiosPost('productrelations', {
                nid: this.id,
                relations: this.productRelations
              }).then(results => {
                if (results && results.data) {
                  this.$message.success('Vzťahy boli uložené');
                }
              }).catch(() => {
                this.$message.error('Pri ukladaní vzťahov nastala chyba');
              });
            },
            testo(e,slug)
            {


                var img = new Image;
                let formData = new FormData();
                const pa = this;
                img.onload = function() {

                        formData.append('upload', e.file);

                    pa.sendImage(formData,slug);

                }

                img.src = URL.createObjectURL(e.file);

                return false
            },
            normFile(e) {

                if (Array.isArray(e)) {
                    return e;
                }
                return e && e.fileList;


            },
            handleEdit() {
                this.$emit('changed', this.datatosave);
            },
            array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    },

            formatDateJD(dt){
                return moment.unix(dt).format('DD.MM. YYYY');
            },
            formatDatedJD(dt){
                return moment(dt).format('DD. MM. YYYY');
            },
    addColfields(fieldindex)
            {
          var fields =  this.contenttype.fields[fieldindex].fields[0];
          this.contenttype.fields[fieldindex].fields.push(fields);

          // Zabezpeč, že pole existuje
          if(!this.fieldData[this.contenttype.fields[fieldindex].slug]) {
            this.$set(this.fieldData, this.contenttype.fields[fieldindex].slug, []);
          }

          this.fieldData[this.contenttype.fields[fieldindex].slug][parseInt(this.fieldData[this.contenttype.fields[fieldindex].slug].length)] = new Array(fields.length).fill("");
          this.componentKey = this.componentKey + 1;
            },

            logf(e)
            {
            console.log(e);
            },
            log(e,slug)
            {
                var arr = JSON.parse(this.fieldData[slug]);


                arr = this.array_move(arr, e.moved.oldIndex, e.moved.newIndex);

                this.fieldData[slug] = JSON.stringify(arr);
            },
            removefc(ind,fieldindex)
            {
                this.contenttype.fields[fieldindex].fields.splice(ind, 1);
                this.fieldData[this.contenttype.fields[fieldindex].slug].splice(ind, 1).filter(val => val);
            },
            onChildChangeBuilder(value,slug) {
                this.fieldData[slug] = JSON.stringify(value);
            },
            formatDate(dt) {

if(moment(dt, moment.ISO_8601, true).isValid())
    return  moment(moment(dt).format('YYYY/MM/DD'));
else
    return moment(moment.unix(dt),'YYYY/MM/DD')
},
formatDateX: function (dt) {
                return moment(dt).format('D.M.YYYY H:mm')

            },
            formatDateS: function (dt) {
                return moment(dt).format('D.M.YYYY')

            },
            formatDateP(dt) {

                if(moment(dt, moment.ISO_8601, true).isValid())
                    return  moment(dt._d).format('lll');
                else
                    return moment.unix(dt).format('lll');


            },
            onChildChangeFc(input,od,ind)
            {
                this.fieldData[this.contenttype.fields[od].slug][od][ind] = input;

            },
            bool(v) {
                return v === 'true' || v === '1';
            },
            updateField(nid,fieldSlug,updateField)
            {
              this.updateNID = nid;
              this.updateFieldSlug = updateField;
              dataService.axiosPost("content/"+nid,{selectedFields:[fieldSlug]}).then(results => {
                console.log(results);
this.updateFieldModal = true;
this.updateFieldModalData = results.data.data;

              });

            },
replaceUpdatedFields(fields) {
  if (!fields) return;
console.log(fields);
  const updatedKeys = Object.keys(fields);

  updatedKeys.forEach(key => {
    const newVal = fields[key];
    this.$set(this.fieldData, key, newVal);
  });
  this.componentKey = this.componentKey +1;
},


            updateFieldDo()
            {
this.updateFieldModalData.data.updateJustFields = true;
              dataService.axiosPost("editcontent/"+this.updateNID,this.updateFieldModalData.data).then(() => {
this.updateFieldModal = false;
this.updateFieldModalData = {};


                dataService.axiosPost("content/"+this.id,{selectedFields:[this.updateFieldSlug]}).then(results2 => {
                   this.replaceUpdatedFields(results2.data.data);
                });
              });

            },
            deleteThis(index,slug)
            {
                let parsed = JSON.parse(this.fieldData[slug]);
                parsed.splice(index, 1);
                this.fieldData[slug] = JSON.stringify(parsed);


            },
            onChange(e,slug)
            {

                if(!this.fieldData[slug])
                    this.fieldData[slug] = [];
                e[0] = e[0].unix();
                e[1] = e[1].unix();
                this.fieldData[slug].push(e);
                this.temp = {};
            },
            remove(index,slug)
            {
                this.fieldData[slug].splice(index, 1);
            },
            onChildChangeMulti(value,slug)
            {
                for(var i in value){
                    this.fieldData[slug] = JSON.stringify(Object.values(value[i]));
                }

            },
            setupImage(image,index,slug)
            {

                this.imageToSet = image;
                this.imageToSet.index = index;
                this.imageToSet.slug = slug;
                this.ImagesetupVisible = true;
            },
            handleGlobalEdit(e,slug)
            {
                 let parsed = JSON.parse(this.fieldData[slug]);
                 parsed.forEach(obj => {
                          obj.image.style = e;
                });

                this.fieldData[slug] = JSON.stringify(parsed);
            },

            openImageModal(fieldSlug)
            {
          this.showImportModalImages = true;
          if(fieldSlug)
          this.fieldSlug = fieldSlug;
            },

showImagesDrag()
{
console.log(this.imagesToAdd);


let fieldsToSend = [];
let ff = {};
  this.contenttype.groups.forEach(obj => {
                  if(obj.child.length)
                    {

obj.child.forEach(objj => {

if(objj.type == 3 || objj.type == 11)
fieldsToSend.push(objj);
ff[objj.slug] = objj.type;
})
                         }
});

   dataService.axiosPost('crawlpicked',{picked:this.imagesToAdd,fields:fieldsToSend}).then((results) => {

   results.data.data.forEach(us => {
   var slug = us.slug;
   let items = [];

   if(ff[slug] != "3")
   {
us.files.forEach(u => {

                   if(this.IsJsonString(this.fieldData[slug]) && this.fieldData[slug] !== null)
                   {
                     items = JSON.parse(this.fieldData[slug]);
                    items.push(u);
                 }
                 else
                {
                        items.push(u);
          }

          })

  this.fieldData[slug] = JSON.stringify(items);
  }
  else
this.fieldData[slug] = us.files;


  this.reloadgalleries++;
  });


                         });

},


             crawlPageImages()
          {

          if(this.fieldSlug)
          {






            this.showImportModalImages = false;
            dataService.axiosPost('crawlpageimage',{url:this.crawlUrl,nid:this.id}).then(results => {
             let items = [];
var slug = this.fieldSlug;
results.data.data.forEach(u => {

                   if(this.IsJsonString(this.fieldData[slug]) && this.fieldData[slug] !== null)
                   {
                     items = JSON.parse(this.fieldData[slug]);
                    items.push(u);
                 }
                 else
                {
                        items.push(u);
          }
})
                    this.fieldData[slug] = JSON.stringify(items);


                    this.reloadgalleries++;


            });
                         }
            else
            {
             dataService.axiosPost('showpageimage',{url:this.crawlUrl,nid:this.id}).then(results => {

    this.contenttype.groups.forEach(obj => {
                  if(obj.child.length)
                    {

obj.child.forEach(objj => {

if(objj.type == 3 || objj.type == 11)
this.imagesToAdd[objj.slug] = [];
})

                    }

                    });
             this.showImages = true;
             this.crawledImages = results.data.data;

             });
            }
                         },
                         openProductSearch(slug)
            {
              this.productSearch = true;
              this.productSlug = slug;


            },
            setupImageOK()
            {
                let parsed = JSON.parse(this.fieldData[this.imageToSet.slug]);
              parsed[this.imageToSet.index].image.title = this.imageToSet.title;
              parsed[this.imageToSet.index].image.style = this.imageToSet.style;
              parsed[this.imageToSet.index].image.alt = this.imageToSet.alt;
              this.fieldData[this.imageToSet.slug] = JSON.stringify(parsed);
                this.ImagesetupVisible = false;
            },
            onSelect(value,slug) {
                this.fieldData[slug] = value;
            },
            priceCompare()
            {

            dataService.axiosFetch("pricecompare/"+this.id).then(results => {
                    console.log(results);
                });

            },
            onSearch(e,f)
            {
                dataService.axiosFetch("dynamic/"+f, e).then(results => {
                    this.options[f] = results;
                });


            },
            jsonU(a)
            {
                var b = JSON.parse(a).map(x=>`"${x}"`).join(",")
                return JSON.parse("[ "+ b + "]");
            },
            onChildChangeMultiP(value,slug)
            {

                this.fieldData[slug] = JSON.stringify(value);
            },
            onchildMultiChange(value,slug)
            {
this.fieldData[slug] = value;
this.fetching = false;
            },
            onChildChange(value,slug) {
                this.fieldData[slug] = JSON.stringify(value);
                this.showoptions = [];
this.fetching = false;
            },

            resolveAddress(slug) {
  const v = this.fieldData[slug]

  // nový formát: { lat, lng } alebo { lat, lng, address }
  if (v && typeof v === 'object' && v.lat !== undefined && v.lng !== undefined) {
    return {
      position: {
        lat: parseFloat(v.lat),
        lng: parseFloat(v.lng),
      },
      address: v.address || null,
    }
  }

  // starý formát – string "lat, lng" v coords[0][0]
  if (
    this.fieldData.coords &&
    this.fieldData.coords[0] &&
    this.fieldData.coords[0][0]
  ) {
    const parts = this.fieldData.coords[0][0].split(',')
    const lat = parseFloat(parts[0])
    const lng = parseFloat(parts[1])
    if (!isNaN(lat) && !isNaN(lng)) {
      return {
        position: { lat, lng },
        address: null,
      }
    }
  }

  // starý formát – objekt gpspoint
  if (
    this.fieldData.gpspoint &&
    this.fieldData.gpspoint.lat !== undefined &&
    this.fieldData.gpspoint.lng !== undefined
  ) {
    const lat = parseFloat(this.fieldData.gpspoint.lat)
    const lng = parseFloat(this.fieldData.gpspoint.lng)
    if (!isNaN(lat) && !isNaN(lng)) {
      return {
        position: { lat, lng },
        address: null,
      }
    }
  }

  return null
},
buildSavePayload() {
  const payload = JSON.parse(JSON.stringify(this.fieldData))

  if (this.contenttype && Array.isArray(this.contenttype.fields)) {
    this.contenttype.fields.forEach(field => {
      // mapové polia – typ 21
      if (field.type === '21') {
        const v = payload[field.slug]
        if (v && typeof v === 'object' && v.lat !== undefined && v.lng !== undefined) {
          // do DB len lat/lng
          payload[field.slug] = {
            lat: v.lat,
            lng: v.lng,
          }
        }
      }
    })
  }

  return payload
},

            onChildTaxChange (value,slug)
            {   this.fieldData[slug] = value;

            },
            handleSubmit() {
                if (!isNaN(this.id)) {
                    this.saving = true;


if (this.contenttype && Array.isArray(this.contenttype.fields)) {
  this.contenttype.fields.forEach(field => {
    if (field.multi === '1' && field.type === '19') {
      if (!Array.isArray(this.fieldData[field.slug])) {
        this.$set(this.fieldData, field.slug, []);
      }

    if (Array.isArray(this.fieldData[field.slug])) {
  this.fieldData[field.slug].forEach(doc => {
    doc.versions?.forEach(version => {
      if (!version.comments) {
        this.$set(version, 'comments', []);
      }
    });
  });
}



    }
  });
}

                    dataService.axiosPost(this.$options.name + "/" + this.id, this.fieldData).then(results => {
                        if (results.data.success) {
                            this.$message.success('Obsah bol upravený');

                            this.fetch();
                            if(results.data.data && results.data.data.revisions)
                            { this.revisions = results.data.data.revisions;
                                this.revision = this.revisions[0].id;
                            }
                         } else {
                            this.$message.error('Pri ukladaní nastala chyba');
                        }
                    });
                }
                else
                { this.saving = true;
                    dataService.axiosPost("addcontent/"+this.id, this.fieldData).then(results => {
                        if(results.data)
                        {
                            this.$router.push('/edit-content/'+results.data[0])
                        }
                    })
                }},
savePressed(e)
{
        if ((window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)  && e.keyCode === 83) {
            if (e.repeat) { return }
            e.preventDefault();
            this.handleSubmit();
        }

},
generate()
{
    this.generating = true;
    dataService.axiosFetch("refractor", this.id).then(results => {
this.generating = false;
this.fieldData["elevation"] = results.elevation;
this.fieldData["mainview"] = results.mainview;
this.fieldData["coords"] = results.coords;

        });
},
     fieldSetup(slug){

this.fieldSetupModal = true;
const objNoReference = JSON.parse(JSON.stringify(slug));
objNoReference.datefrom = false;
objNoReference.nid = this.id;
this.slugSave = objNoReference;
},
showschedule(slug)
            {
              this.slugSave = slug;
              this.schedulemodal = true;

            },
             removeScheduled(id)
            {
              dataService.axiosDelete('scheduledfield', id);
              this.schedulemodal = false;
              this.fetch();
            },
generateGPX()
{


    this.gpxLoader = true;

               this.fieldData["mainview"] = "";
        dataService.axiosPost("generateGPX", { gps: this.fieldData["gpspoint"], title:  this.fieldData["title"] }).then(results => {
this.fieldData["file"] = results.data.data.file;
this.fieldData["json"] = results.data.data.json;
this.fieldData["centerpoint"] = results.data.data.centerpoint;
//this.fieldData["coords"][0][0] = JSON.parse(results.data.data.centerpoint)[1] + ", " + JSON.parse(results.data.data.centerpoint)[0];
this.fieldData["coords"][0][0] = results.data.data.pointLL;
this.fieldData["coords"][0][1] = results.data.data.pointDMS;

this.fieldData["length"] = results.data.data.length;

this.gpxLoader = false;
        });
},
getCTdetail(user, entity = false)
{
    this.exampleModal = true;
    this.loadingModal = true;
  this.hideChoose = false;
  if(!user)
  {
    user = {};
    user.entity_id = entity;
this.hideChoose = true;
  }

 dataService.axiosFetch('content', user.entity_id + "/true").then(results => {
    this.exampleData = results;
    this.loadingModal = false;
 })

},
 addedGPX(e)
            {

             if (e.fileList !== undefined)
               {
               let filedatas = e.fileList[0].response[0];
               if(!e.event)
               {
                filedatas["original"] = filedatas["uri"];
               this.fieldData["file"] = filedatas;
               this.fieldData["mainview"] = "";
               this.mapID = filedatas["original"];

 dataService.axiosPost("generateGPX", { fid: this.mapID}).then(results => {

this.fieldData["json"] = results.data.data.json;
this.fieldData["centerpoint"] = results.data.data.centerpoint;
//this.fieldData["coords"][0][0] = JSON.parse(results.data.data.centerpoint)[1] + ", " + JSON.parse(results.data.data.centerpoint)[0];
this.fieldData["coords"][0][0] = results.data.data.pointLL;
this.fieldData["coords"][0][1] = results.data.data.pointDMS;

this.fieldData["length"] = results.data.data.length;

this.gpxLoader = false;

});

               }}
            },
           handleAutoSave(slug) {
    const fieldValue = this.fieldData[slug];

    // Vlož aktuálnu hodnotu do tela
    const payload = {
      slug: slug,
      value: fieldValue,
      id: this.id,
    };

    // Odoslať cez API alebo zavolať save funkciu
    this.saveField(slug, payload);

  },

  async saveField(slug, payload) {
    try {
      await dataService.axiosPost('savefield', payload);
      this.$message.success(`Automaticky uložené.`);
      this.nodeStatsCall()
    } catch (e) {
      this.$message.error(`Chyba pri ukladaní.`);
    }
  },
            fetch(){
let wtgId = this.id;

let wtg = "content";
if(this.mid)
{
wtgId = this.mid;
wtg = "track";
}

dataService.axiosFetch('translatenode', this.id).then(results => {
                        if(results)
                        this.translations = results;
                     });


 dataService.axiosFetch(wtg, wtgId + "/true").then(results => {
    this.fieldData = results.data
    this.created = results.created;
    this.modified = results.modified;
    this.vars = results.vars

    // Fetch site_id pre resync button
    dataService.axiosFetch('variable/site_id').then(r => {
      if (r && r.site_id) this.$set(this.vars, 'site_id', r.site_id);
    });

    this.contenttype = results.contenttypes
    this.context = results.context;
    this.ctt = results.ct;
    this.hasOwntitle = this.fieldData.title;



    if(results.productOptionsCategories)
      {
        this.hasProductOptions = true;
        this.productOptionsCategories = results.productOptionsCategories;
        this.productOptions = results.productOptions;
      }

    this.fetchProductRelations();
  this.contenttype.fields.forEach(obj => {
  if(obj.slug == "builder")
  this.hasBuilder = true;

if(obj.type === '17' && obj.multi === '1')
{
  if(!this.fieldData[obj.slug])
  this.fieldData[obj.slug] = [];
}

if(obj.type === '19' && obj.multi === '1')
{
  this.hasMultiDocuments = true;
  if(!this.fieldData[obj.slug])
  this.fieldData[obj.slug] = [];
}

  if(obj.type === '22')
  {
  if(!this.fieldData[obj.slug])
  this.fieldData[obj.slug] = [];
  }


if (obj.type === '9' && obj.slug === 'beecount') {
  const raw = this.fieldData.beecount;

  // nič v DB → prázdna štruktúra
  if (!raw) {
    this.$set(this.fieldData, 'beecount', {
      count: null,
      validFrom: null
    });
  }
  // v DB je uložené JSON ako string → parse
  else if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      this.$set(this.fieldData, 'beecount', {
        count: parsed && parsed.count != null ? Number(parsed.count) : null,
        validFrom: parsed && parsed.validFrom
          ? this.moment(parsed.validFrom, 'YYYY-MM-DD')  // pre <a-date-picker>
          : null
      });
    } catch (e) {
      // ak parse zlyhá, radšej inicializuj nanovo
      this.$set(this.fieldData, 'beecount', {
        count: null,
        validFrom: null
      });
    }
  }
// už je to objekt → len zabezpeč moment pre date-picker
else if (typeof raw === 'object') {
  if (raw.validFrom && !moment.isMoment(raw.validFrom)) {
    raw.validFrom = moment(raw.validFrom, 'YYYY-MM-DD');
  }
}

}




  });

if(this.fieldData.file){
    this.mapID = this.fieldData.file.original
}



  let roleops = { "name": "Všeobecné","child": []};
  this.contenttype.groups.forEach(obj => {
  if(obj.pid === "0" && !obj.child.length)
  {
      roleops["child"].push(obj)
  }

  });
if(roleops)
{
  this.contenttype.groups = this.contenttype.groups.slice();
  this.contenttype.groups.unshift(roleops);
}
this.contexts = results.context
this.options = results.options

this.next = results.next
this.prev = results.previous

this.ct = results.ctt
  this.revisions = results.revisions;
if(this.revisions)
{
    this.revision = this.revisions[0].id;
}
this.cttt = results.cttt
this.saving = false;

this.contenttype.fields.forEach(field => {
  if (field.multi === '1' && field.type === '19') {
    const slug = field.slug;

    // Uisti sa, že fieldData[slug] je pole
    if (!Array.isArray(this.fieldData[slug])) {
      this.$set(this.fieldData, slug, []);
    }

    // Prejdi všetky dokumenty
    this.fieldData[slug].forEach(doc => {
      if (Array.isArray(doc.versions)) {
        doc.versions.forEach(ver => {
          if (!ver.hasOwnProperty('comments')) {
            this.$set(ver, 'comments', []);
          }
        });
      }
    });

  }
});
                });


                this.historic = {};

if (!isNaN(this.id)) {
  dataService.axiosFetch('fieldhistoric/' + this.id).then(res => {
    const rows = res && res.rows ? res.rows : [];

    const grouped = {};

    rows.forEach(r => {
      const slug = r.slug || r.field_name;

      if (!grouped[slug]) {
        grouped[slug] = [];
      }

      grouped[slug].push({
        id: r.id,
        nid: r.nid || r.entity_id,
        slug: slug,
        value: r.value,
        old_value: r.old_value,
        date: r.date || (r.changed_at ? r.changed_at.substr(0, 10) : null),
        valid_from: r.valid_from || r.date || (r.changed_at ? r.changed_at.substr(0, 10) : null),
        changed_at: r.changed_at,
        user_id: r.user_id || r.changed_by
      });
    });

    // zoradenie v rámci každého poľa podľa dátumu (najnovší hore)
    Object.keys(grouped).forEach(slug => {
      grouped[slug].sort((a, b) => {
        const da = a.valid_from || a.date;
        const db = b.valid_from || b.date;
        return da < db ? 1 : -1;
      });
    });

    this.historic = grouped;
    console.log(this.historic);
  });
}




            },
async reloadHistoric(slug) {
  if (!slug || isNaN(this.id)) {
    return;
  }

  try {
    const res = await dataService.axiosPost('getfieldhistoric/' + this.id, { slug: slug });
    const data = res && res.data && res.data.data ? res.data.data : {};
    const rawRows = data.rows || [];

    const rows = this.normalizeHistoricRows(rawRows, slug, this.id);

    this.$set(this.historic, slug, rows);
  } catch (e) {
    console.error(e);
    this.$message.error('Chyba pri načítaní histórie.');
  }
},
            nodeStatsCall()
            {
            this.nodeStats = [];
            this.history = [];

              dataService.axiosFetch('nodestats/' + this.id).then(results => {
            this.nodeStats = results.stats;
            this.history = results.history;
            });
            },
            restoreHistory(historyId) {
              return dataService.axiosFetch('nodehistory/restore/' + historyId);
            },
            previewHistory(item) {
              this.restoringHistoryId = item.id;
              this.historyDiffLoading = true;
              this.historyDiffVisible = true;
              this.historyDiffFields = [];
              this.historyDiffMeta = { user: item.user, date: this.formatDateX(item.created) };
              this.historyDiffBackup = null;
              this.historyDiffViewMode = 'text';
              this.historyDiffPreviewCurrent = null;
              this.historyDiffPreviewBackup = null;
              this.historyDiffHasBuilder = false;

              // Build slug→title map from contenttype
              const titleMap = {};
              if (this.contenttype && this.contenttype.groups) {
                this.contenttype.groups.forEach(g => {
                  if (g.child) g.child.forEach(f => { titleMap[f.slug] = f.title; });
                });
              }
              titleMap['builder'] = 'BetaEditor';
              titleMap['title'] = 'Názov';
              titleMap['url'] = 'URL';
              titleMap['language'] = 'Jazyk';
              titleMap['published'] = 'Publikované';
              titleMap['koncept'] = 'Koncept';
              titleMap['seotitle'] = 'SEO Titulok';
              titleMap['seodescription'] = 'SEO Popis';
              titleMap['seokeywords'] = 'SEO Kľúčové slová';

              this.restoreHistory(item.id).then(results => {
                if (!results) {
                  this.$message.error('Pri načítaní zálohy nastala chyba');
                  this.historyDiffVisible = false;
                  return;
                }
                this.historyDiffBackup = results;
                const diffs = [];
                const skipKeys = ['updated', 'created'];
                const allKeys = new Set([...Object.keys(this.fieldData), ...Object.keys(results)]);
                allKeys.forEach(key => {
                  if (skipKeys.includes(key)) return;
                  if (key.endsWith('_data') || key.endsWith('_datax')) return;
                  const current = this.fieldData[key];
                  const backup = results[key];
                  const curStr = this.normalizeForDiff(current);
                  const bakStr = this.normalizeForDiff(backup);
                  if (curStr !== bakStr) {
                    const entry = {
                      key: key,
                      label: titleMap[key] || key,
                      currentHtml: this.diffEscape(curStr),
                      backupHtml: this.diffEscape(bakStr)
                    };
                    if (key === 'builder') {
                      this.historyDiffHasBuilder = true;
                      entry.currentRaw = this.formatBuilderText(current);
                      entry.backupRaw = this.formatBuilderText(backup);
                    }
                    diffs.push(entry);
                  }
                });
                this.historyDiffFields = diffs;

                // Fetch previews for builder if changed
                if (this.historyDiffHasBuilder) {
                  this.fetchBuilderPreview(this.fieldData.builder, 'current');
                  this.fetchBuilderPreview(results.builder, 'backup');
                }
              }).catch(() => {
                this.$message.error('Pri načítaní zálohy nastala chyba');
                this.historyDiffVisible = false;
              }).finally(() => {
                this.restoringHistoryId = null;
                this.historyDiffLoading = false;
              });
            },
            diffEscape(str) {
              if (!str) return '<span class="text-muted">—</span>';
              const escaped = str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
              if (escaped.length > 500) return '<pre class="diff-pre">' + escaped.substring(0, 500) + '…</pre>';
              return '<pre class="diff-pre">' + escaped + '</pre>';
            },
            normalizeForDiff(val) {
              if (val === null || val === undefined) return '';
              if (val === false || val === 0) return String(val);
              if (typeof val === 'object') {
                try { return JSON.stringify(val, null, 2); } catch(e) { return String(val); }
              }
              return String(val);
            },
            applyHistoryRestore() {
              if (this.historyDiffBackup) {
                this.fieldData = Object.assign({}, this.fieldData, this.historyDiffBackup);
                this.$message.success('Stav bol obnovený. Pre uloženie stlačte Uložiť.');
              }
              this.historyDiffVisible = false;
            },
            formatBuilderText(val) {
              if (!val) return '(prázdne)';
              try {
                const arr = typeof val === 'string' ? JSON.parse(val) : val;
                if (!Array.isArray(arr)) return typeof val === 'string' ? val : JSON.stringify(val, null, 2);
                return arr.map((comp, i) => {
                  const name = comp.component || '(neznámy)';
                  const data = comp.data || {};
                  const parts = [i + 1 + '. ' + name];
                  Object.keys(data).forEach(k => {
                    if (k === 'view' || k === 'items') return;
                    const v = data[k];
                    if (v && typeof v === 'object') {
                      parts.push('  ' + k + ': ' + JSON.stringify(v));
                    } else if (v !== undefined && v !== null && v !== '') {
                      parts.push('  ' + k + ': ' + v);
                    }
                  });
                  return parts.join('\n');
                }).join('\n\n');
              } catch(e) {
                return typeof val === 'string' ? val : JSON.stringify(val, null, 2);
              }
            },
            fetchBuilderPreview(builderVal, target) {
              let builderArr;
              try {
                builderArr = typeof builderVal === 'string' ? JSON.parse(builderVal) : builderVal;
              } catch(e) { return; }
              if (!builderArr || !Array.isArray(builderArr)) return;
              dataService.axiosPost('showpage', { builder: builderArr, id: this.id }).then(results => {
                if (results && results.data && results.data.data) {
                  const dataObj = results.data.data;
                  const keys = Object.keys(dataObj).filter(k => k !== 'parent');
                  if (keys.length > 0) {
                    const hideWidgets = '<style>#cookiescript_badge, #smartsupp-widget-container { display: none !important; }</style>';
                    const html = dataObj[keys[0]].replace('</head>', hideWidgets + '</head>');
                    if (target === 'current') this.historyDiffPreviewCurrent = html;
                    else this.historyDiffPreviewBackup = html;
                  }
                }
              });
            },
            fetchPriceStats(days) {
              this.priceStatsLoading = true;
              const url = days ? 'pricestats/' + this.id + '/' + days : 'pricestats/' + this.id;
              dataService.axiosFetch(url).then(results => {
                this.priceStats = results || null;
                this.priceStatsLoading = false;
              }).catch(() => {
                this.priceStats = null;
                this.priceStatsLoading = false;
              });
            },
            priceStatsDiffClass(diff) {
              if (diff === null || diff === undefined) return '';
              return diff < 0 ? 'price-lower' : diff > 0 ? 'price-higher' : '';
            },
            formatPrice(val) {
              if (val === null || val === undefined) return '—';
              return val.toFixed(2) + ' €';
            },
            formatDiff(val) {
              if (val === null || val === undefined) return '—';
              const sign = val > 0 ? '+' : '';
              return sign + val.toFixed(2) + ' %';
            },
            channelLabel(key) {
              const labels = {
                heureka_sk: 'Heureka SK',
                heureka_cz: 'Heureka CZ',
                idealo: 'Geizhals',
                hifiklubben: 'HiFi Klubben',
                ceneo: 'Ceneo',
                alza_sk: 'Alza SK',
              };
              return labels[key] || key;
            },
            updateMultiOrder()
            {
this.componentKey = this.componentKey + 1;
            },
            getAllOptions(inslug)
            {
                this.showoptions = this.options[inslug];
            },
            compareData(search,inslug)
            {
              let searchTerm =search.toLowerCase();
if(inslug.componentOptions.children[0].text.toLowerCase().includes(searchTerm))
return true;
            },
            updateGPS(){

            this.fieldData["coords"][0][0] = this.lat + ", " + this.lng;
            this.fieldData["gpspoint"] = {"lat": this.lat,"lng": this.lng};
              dataService.axiosPost("generateGPX", { gps: this.fieldData["gpspoint"], title:  this.fieldData["title"] }).then(results => {
this.fieldData["file"] = results.data.data.file;
this.fieldData["json"] = results.data.data.json;
this.fieldData["centerpoint"] = results.data.data.centerpoint;
this.fieldData["coords"][0][0] = JSON.parse(results.data.data.centerpoint)[1] + ", " + JSON.parse(results.data.data.centerpoint)[0];
this.gpxLoader = false;
this.mapID = this.fieldData["file"].original;
        });
            },
            revert()
            {
              if(this.revision)
              {
                  this.fieldData = {};

                  dataService.axiosFetch("revision", this.revision).then(results => {
                      this.fieldData = results.data
                      this.vars = results.vars
                      this.contexts = results.context
                      this.options = results.options
                      this.refreshAll = this.refreshAll + 1;
                  });
                  this.revisionsShow = false;
              }
            },
          async fetchConvertedPdf(uri) {
  const filename = uri.split('/').pop();

  try {
    const res = await dataService.axiosFetch("convertdocx", filename);
    console.log(res);
    if (res.pdf) {
      this.pdfResolvedUrl = res.pdf;
    } else {
      this.$message.error('Nepodarilo sa načítať PDF');
    }
  } catch (e) {
    console.error(e);
    this.$message.error('Chyba pri konverzii dokumentu');
  }
},
            handleChange(info,slug) {

                this.fieldData[slug] = null;
                if (info.file.status === 'done') {
                    this.fieldData[slug] = info.file.response[0]
                } else if (info.file.status === 'error') {
                    this.fieldData[slug] = ""
                }
            },
        },
        watch: {
  'pdfPreviewData.uri': {
    immediate: true,
    handler(newVal) {
      if (!newVal) {
        this.pdfResolvedUrl = '';
        return;
      }

      const ext = newVal.split('.').pop().toLowerCase();
      if (ext === 'pdf') {
        this.pdfResolvedUrl = newVal;
      } else if (ext === 'docx' || ext === 'doc') {
        // Spusti konverziu
        this.fetchConvertedPdf(newVal);
        this.pdfResolvedUrl = ''; // zatiaľ nič
      } else {
        this.pdfResolvedUrl = '';
      }
    }
  }
},
        computed: {
           detailTabPosition() {
             return this.windowWidth < 768 ? 'top' : 'left';
           },
           hasAnyProductRelation() {
             if (!this.productRelations) return false;
             const r = this.productRelations;
             return !!(r.parent || (r.variants && r.variants.length) || (r.configurable && r.configurable.length) || (r.accessories && r.accessories.length) || (r.usedAsAccessoryIn && r.usedAsAccessoryIn.length) || (this.fieldData.rows && this.fieldData.rows.length));
           },
           defaultProductRelationTab() {
             if (!this.productRelations) return 'rel-accessories';
             if (this.productRelations.parent || (this.productRelations.variants && this.productRelations.variants.length)) return 'rel-variants';
             if (this.productRelations.configurable && this.productRelations.configurable.length) return 'rel-configurable';
             if (this.productRelations.accessories && this.productRelations.accessories.length) return 'rel-accessories';
             if (this.productRelations.usedAsAccessoryIn && this.productRelations.usedAsAccessoryIn.length) return 'rel-used-as';
             return 'rel-accessories';
           },
           accessoriesBySortiment() {
             if (!this.productRelations || !this.productRelations.accessories) return {};
             const groups = {};
             this.productRelations.accessories.forEach(a => {
               const key = a.category || 'Ostatné';
               if (!groups[key]) groups[key] = [];
               groups[key].push(a);
             });
             return groups;
           },
           productRelationImageFallback() {
             if (this.fieldData && this.fieldData.image) {
               const img = this.fieldData.image;
               if (typeof img === 'string' && img) return img;
               if (img.styled) return img.styled;
               if (img.uri) return img.uri;
             }
             if (this.productRelations && this.productRelations.parent && this.productRelations.parent.image) return this.productRelations.parent.image;
             return null;
           },
           beekeeperFields() {
    const f = {}

    if (this.fieldData && this.fieldData.address) {
      f.address = this.fieldData.address
    }

    if (this.fieldData && this.fieldData.city) {
      f.city = this.fieldData.city_data.title
    }

    return f
  },
    computedLabels() {
      if (this.nodeStats.length) {
        return this.nodeStats.map(entry => {
          // Vytvorí objekt Date a formátuje ako "deň mesiac" (napr. "2 mar")
          const d = new Date(entry.date)
          // Používame slovenské nastavenie pre mesiac
          return `${d.getDate()} ${d.toLocaleString('sk', { month: 'short' })}`
        })
      }
      // Fallback: slovenské skratky dní
      return ['Po', 'Ut', 'St', 'Št', 'Pi', 'So', 'Ne']
    },

    computedDatasets() {
      const brandInfo =  '#20a8d8'

      if (this.nodeStats.length) {
        const sessionsData = this.nodeStats.map(entry => entry.Clicks)
        return [
          {
            label: 'Počet kliknutí',
            backgroundColor: 'transparent',
            borderColor: brandInfo,
            pointHoverBackgroundColor: brandInfo,
            borderWidth: 2,
            data: sessionsData
          }
        ]
      }

      // Fallback: nulové dáta, aby graf zobrazoval rovný priebeh
      const labels = this.computedLabels
      const flatData = labels.map(() => 0)
      return [
        {
          label: 'Počet kliknutí',
          backgroundColor: brandInfo,
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: flatData
        },
      ]
    },
    yAxesMax() {
      // Vypočíta maximálnu hodnotu a pridá 20% maržu
      if (this.nodeStats.length) {
        let maxVal = 0
        this.nodeStats.forEach(entry => {
          maxVal = Math.max(maxVal, entry.Clicks)
        })
        return Math.ceil(maxVal * 1.2)
      }
      return 250
    },
    defaultOptions() {
      return {
        maintainAspectRatio: false,
        legend: { display: true },
        scales: {
          xAxes: [{
            gridLines: { drawOnChartArea: false },
            ticks: {
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: Math.ceil(this.yAxesMax / 5),
              max: this.yAxesMax
            },
            gridLines: { display: true }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }
    },
    priceChartLabels() {
      if (!this.priceStats || !this.priceStats.history) return [];
      return this.priceStats.history.map(row => {
        const d = new Date(row.date);
        return `${d.getDate()} ${d.toLocaleString('sk', { month: 'short' })}`;
      });
    },
    priceChartDatasets() {
      if (!this.priceStats || !this.priceStats.history || !this.priceStats.history.length) return [];
      const history = this.priceStats.history;
      const ourPrice = history.map(r => r.our_price);
      const globalLowest = history.map(r => {
        const vals = Object.values(r.channels).map(c => c.lowest).filter(v => v !== null);
        return vals.length ? Math.min(...vals) : null;
      });
      const globalHighest = history.map(r => {
        const vals = Object.values(r.channels).map(c => c.highest).filter(v => v !== null);
        return vals.length ? Math.max(...vals) : null;
      });
      return [
        {
          label: 'Naša cena',
          backgroundColor: 'transparent',
          borderColor: '#20a8d8',
          pointHoverBackgroundColor: '#20a8d8',
          borderWidth: 2,
          data: ourPrice
        },
        {
          label: 'Najnižšia na trhu',
          backgroundColor: 'rgba(245,34,45,0.08)',
          borderColor: '#f5222d',
          pointHoverBackgroundColor: '#f5222d',
          borderWidth: 2,
          borderDash: [5, 3],
          data: globalLowest
        },
        {
          label: 'Najvyššia na trhu',
          backgroundColor: 'rgba(82,196,26,0.08)',
          borderColor: '#52c41a',
          pointHoverBackgroundColor: '#52c41a',
          borderWidth: 2,
          borderDash: [5, 3],
          data: globalHighest
        }
      ];
    },
    priceChartOptions() {
      return {
        maintainAspectRatio: false,
        legend: { display: true },
        tooltips: {
          callbacks: {
            label: function(item, data) {
              const label = data.datasets[item.datasetIndex].label || '';
              const val = item.yLabel;
              return val !== null ? label + ': ' + val.toFixed(2) + ' €' : label + ': —';
            }
          }
        },
        scales: {
          xAxes: [{ gridLines: { drawOnChartArea: false } }],
          yAxes: [{
            ticks: { beginAtZero: false, maxTicksLimit: 6 },
            gridLines: { display: true }
          }]
        },
        elements: {
          point: { radius: 2, hitRadius: 10, hoverRadius: 4, hoverBorderWidth: 3 }
        }
      };
    },
           latestDocumentKey() {
    const slug = this.currentUploadSlug || '';
    let latest = { key: '', date: 0 };

    this.contenttype.fields.forEach(field => {
      if (field.type === '19' && field.multi === '1') {
        const docs = this.fieldData[field.slug];
        if (Array.isArray(docs)) {
          docs.forEach((doc, index) => {
            const latestVersion = doc.versions?.[doc.versions.length - 1];
            if (latestVersion && latestVersion.uploaded_at > latest.date) {
              latest = { key: field.slug + '_' + index, date: latestVersion.uploaded_at };
            }
          });
        }
      }
    });

    return latest.key;
  },
            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },
        created() {
            document.addEventListener("keydown", this.savePressed);
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.savePressed);
            window.removeEventListener('resize', this.handleResize);
        },
        mounted() {

          window.addEventListener('resize', this.handleResize);
          this.nodeStatsCall();
          this.fetchPriceStats(this.priceStatsDays);
          dataService.axiosFetch('languages').then(results => {
                this.languages = results;
                results.forEach(obj => {
                    if(obj.def === "1")
                    this.defaultLanguage = obj.short;
                    this.translations[obj.short] = {};
                });

            });

          if (!isNaN(this.id) || !isNaN(this.mid) ) {

this.fetch();

            }
            else
            {

                 if(this.id)
                {
                 dataService.axiosFetch("contenttype", this.id).then(results => {

                this.contenttype = results


                this.fieldData = results.data
             let roleops = { "name": "Všeobecné","child": []};
                    this.contenttype.groups.forEach(obj => {



if (obj.type === '9' && obj.slug === 'beecount') {
  const raw = this.fieldData.beecount;

  // nič v DB → prázdna štruktúra
  if (!raw) {
    this.$set(this.fieldData, 'beecount', {
      count: null,
      validFrom: null
    });

    console.log(this.fieldData);
  }
  // v DB je uložené JSON ako string → parse
  else if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      this.$set(this.fieldData, 'beecount', {
        count: parsed && parsed.count != null ? Number(parsed.count) : null,
        validFrom: parsed && parsed.validFrom
          ? this.moment(parsed.validFrom, 'YYYY-MM-DD')  // pre <a-date-picker>
          : null
      });
    } catch (e) {
      // ak parse zlyhá, radšej inicializuj nanovo
      this.$set(this.fieldData, 'beecount', {
        count: null,
        validFrom: null
      });
    }
  }
  // už je to objekt → len zabezpeč moment pre date-picker
  else if (typeof raw === 'object') {
    if (raw.validFrom && !this.moment.isMoment(raw.validFrom)) {
      raw.validFrom = this.moment(raw.validFrom, 'YYYY-MM-DD');
    }
  }
}





                        if(obj.pid === "0" && !obj.child.length)
                        {
                            roleops["child"].push(obj)
                        }
                    });
                    if(roleops)
                    {
                       this.contenttype.groups = this.contenttype.groups.slice();
                       this.contenttype.groups.unshift(roleops);
                    }
                if(Array.isArray(results.data) && !results.data.length)
                    this.fieldData = {}






                this.contexts = results.context
                this.options = results.options
                this.ct = results.ctt
            });
            }
            }
            dataService.axiosFetch('imagestyles').then(results => {
                const entries = Object.entries(results)
                this.styles.push({'value': '','title':  'Original'});
                for (const [r, key] of entries) {
                    this.styles.push({'value': r,'title':  r + ' - ' + key[0]+ ' x '+ key[1]+'px'});
                }
            });
            dataService.axiosFetch('languages').then(results => {
                this.languages = results;
                results.forEach(obj => {
                    this.translations[obj.short] = {};
                });

            });

        }
    };
</script>
<style scoped>

    .input-group .input-group-prepend .input-group-text {
        border: 0;
    }

    .dynamic-delete-button {
        cursor: pointer;
        position: relative;
        top: 4px;
        font-size: 24px;
        color: #999;
        transition: all 0.3s;
    }
    .add-button i
    {
        position: relative;
        top: -3px;}
    .dynamic-delete-button:hover {
        color: #777;
    }

    .dynamic-delete-button[disabled] {
        cursor: not-allowed;
        opacity: 0.5;
    }
    .page-title
    {min-height:30px}
    .ant-select-selection--single {
        width: 100%;
        height: calc(1.5em + 1.25rem + 2px);
        padding: .625rem .75rem;
    }
    .date-delete
    {float:left;margin-right:15px;margin-top:-3px;}
    .date-row{
        display: inline-block;
        width: 100%;
        border-bottom: 1px solid #e9ecfa;
        margin: 0px;
        padding: 8px;
        margin-bottom:10px;
        margin-top:-10px;
    }

    .gallery-image-holder img.big
    {height:100%;width:auto;display:block;margin:0 auto;
}

     .demo-image
    {top:0;
         position:absolute;
    width:80px;height:80px;
         border:2px solid #1d2226;
         background-color:#1d2226;
        padding:3px;
         right:-90px;
        display:none;
    }
    .ant-select-selection--multiple .ant-select-search--inline .ant-select-search__field
    {
    height: 40px;
    padding-left: 7px;
    }
    .ant-select-selection--multiple > ul > li, .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
    height: 42px;
    margin-top: 0px;
    line-height: 45px;
}
    .sub-translations
    {margin-top:4px;}
    #app .sub-translations >>> .ant-input, #app .sub-translations >>> .ant-select-selection--single, #app .sub-translations >>> input.form-control, #app .sub-translations >>> .ant-input-number
     {border-color: #dcedff;}
    .sub-translations i
    {color: #aecbdf
    }
    .demo-image img
    {max-width:100%;max-height:100%;}
    .ql-editor >>> strong, .ql-editor >>> b
    {font-weight:bold}
.gallery-images
{width:100%;display:inline-block;}
    .gallery-image-holder .title
    {position:absolute;width:100%;text-align:left;font-size:12px;color:#1d2226;font-weight:bold;
        max-width:200px;overflow:hidden;bottom:15px;left:5px;}
    .gallery-image-holder .alttag
    {position:absolute;width:100%;text-align:left;font-size:12px;color:#1d2226;
        max-width:200px;overflow:hidden;bottom:3px;left:5px;}
    .image-setup
    {
        display:block;
        width:100%;
        bottom:-2px;
        right:-2px;
        position:absolute;
        z-index:9;
        color:#1d2226;
        text-align:right;
    }
    .list-group
    {display:block;}
    .image-setup i:hover
    {background-color:#d31e40;
    cursor:pointer;}
    .setup-panel
    {display:inline-block;
    width:100%;position:relative;}
    .handle2
    {    position: absolute;
    left: -34px;
    background-color: #eff4ff;
    padding: 10px;
    border-radius: 6px;
    border: 2px solid #fff;
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;}
    .show-example
    {position:relative;}
    .show-example img
    {margin:0 auto;}
    .show-example:hover .demo-image
    {display:block;}
    .btn-inner--icon i.fad
    {top:0}
    .action-button-gpx, .action-button-gpx >>> .ant-upload.ant-upload-select
    {
     float:right;
     margin-left:3px;
    }
.descripion-minheight
{
  min-height:10px;
  border-bottom: 1px solid #f0f0f0;
}
.document-block hr
{border-color: #f0f0f0}
.descripion-minheight.no-description {
  padding-bottom: 5px;
  }
.descripion-minheight.no-description h5{
  line-height:35px;
}
    .action-button-gpx span
    { padding: 10px 0;
    }
.version-box {
  flex-grow: 1;
}
.dgallery-image
{width:100%;display:block;
    border:1px solid #ddd;padding:5px; margin:5px;}
.draggable-gallery-image
{display:inline-block;
min-height:60px;width:100%;
border:1px solid #000;}
.prev-next
{display:block;float:left; text-align:right;}
.prev-next a
{margin-right:3px; font-size:10px;}
.prev-next a button
{ font-size:12px;}
    .image-setup i
    {
padding:10px;
        color:#fff;
        font-weight:bold;
        background-color: #000000;
        margin:2px;
    }

.productCombo >>> .beta-image img
{max-height:80px;width:auto!important; margin:0 auto;}
    #app .top-bar >>> input.ant-input
    {height:40px;}
    .form-item-holder
    {position:relative;}
   .form-control-label,.ant-select
    {width:100%;
    display:inline-block;}
    .auto-url:hover
    {cursor:pointer;
        color: #0b80e4;
        text-shadow: 0px 0px 1px #0089ff;}
    .auto-url
    {position:absolute;
        top:47px;
    right:18px;}
    .ck.ck-balloon-panel
    {z-index:999999!important;}
    .del-but{position:absolute;right:20px;top:8px;}
     .edit-card >>> .ant-card-body
     {padding:0;}
   p
{font-weight:initial!important;}

    .ant-tabs >>> .ant-tabs-left-bar .ant-tabs-nav .ant-tabs-tab-active
    {font-weight:initial!important}
.page-editor >>> .ant-tabs-nav-wrap
{
  background-color: #f8f9fa;
  border-top:1px solid #ececec;
}
.page-editor >>> .ant-form-item label
{padding-right:12px;
  line-height:2.5;
white-space: break-spaces;
}
.version-entry {
  border-top: 1px solid #f1f1f1;
  padding-top: 8px;
}

.header-row
{padding:3px;text-align:center;}
.selectable-row-noflex td {
    background-color: #fff;
}

.finduserModal >>> .ant-modal-body
{padding: 10px 20px;}

.finduserModal .ant-input-search
{margin-bottom:20px;}

.selectable-row-noflex:hover td {
    background-color: #f7f7f7;
}
.document-block {
  background-color: #fff;
  box-shadow: 0 0 3px rgba(0,0,0,0.05);
}

@media (max-width: 768px) {
  .document-block .d-flex {
    flex-direction: column;
  }

  .document-block .text-right {
    text-align: left !important;
    margin-top: 10px;
  }
}

.history-table { border-collapse: collapse; font-size: 13px; }
.history-table tr { border-bottom: 1px solid #f0f0f0; }
.history-table tr:last-child { border-bottom: none; }
.history-table td { padding: 7px 10px; vertical-align: middle; }
.history-action { font-weight: 500; white-space: nowrap; }
.history-meta { white-space: nowrap; text-align: right; }
.history-date { white-space: nowrap; text-align: right; color: #94a3b8; font-size: 12px; }
.history-btn { white-space: nowrap; }
.history-explanation { width: 100%; }
.history-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
}
.history-row:last-child {
  border-bottom: none;
}
.history-row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.history-diff-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.history-diff-table th,
.history-diff-table td {
  padding: 8px 10px;
  border: 1px solid #f0f0f0;
  vertical-align: top;
}
.history-diff-table thead th {
  background: #fafafa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
}
.diff-row-changed .diff-current {
  background: #fff1f0;
}
.diff-row-changed .diff-backup {
  background: #f6ffed;
}
.diff-cell {
  max-height: 200px;
  overflow-y: auto;
}
.diff-pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  font-family: inherit;
  background: transparent;
  max-height: 300px;
  overflow-y: auto;
}
.diff-preview-frame {
  min-height: 300px;
}
.diff-iframe {
  width: 100%;
  height: 400px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

/* Product relations */
.accessories-group {
  margin-bottom: 12px;
}
.accessories-group-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #999;
  padding: 6px 0 4px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 4px;
}
.product-relation-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.product-relation-item:last-child {
  border-bottom: none;
}
.product-relation-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}
.product-relation-thumb--empty {
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  font-size: 16px;
}
.product-relation-info {
  flex: 1;
  min-width: 0;
}
.product-relation-price {
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Price stats */
.price-stats-panel {
  padding: 12px;
}
.price-stats-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.price-stats-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.price-stats-table th,
.price-stats-table td {
  padding: 6px 10px;
  border-bottom: 1px solid #f0f0f0;
  white-space: nowrap;
}
.price-stats-table thead th {
  background: #fafafa;
  font-weight: 600;
  text-align: left;
}
.price-stats-subheader th {
  font-weight: 400;
  font-size: 11px;
  color: #999;
}
.price-diff {
  display: block;
  font-size: 11px;
  opacity: 0.7;
}
.price-lower {
  color: #f5222d;
}
.price-higher {
  color: #52c41a;
}
@media (max-width: 991px) {
  .price-stats-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .price-stats-table {
    font-size: 12px;
  }
  .price-stats-table th,
  .price-stats-table td {
    padding: 4px 6px;
  }
}

.sidebar-sticky{position:sticky;top:20px;padding-top:0!important;align-self:flex-start}
.sidebar-actions-col .card{padding-top:0!important}
</style>
